(function () {
  'use strict';

  // Ladezeit (Tan 2026-11-02): Viele Funktionen beobachten die ganze Seite. Änderungen, die für keine
  // eigene Anpassung zählen, lösen keine Neuberechnung mehr aus: Sekunden-Countdowns (Lieferdatum,
  // Versand-Countdown im Warenkorb), der Fortschrittsbalken des Startseiten-Sliders und Skripte im <head>.
  const HX_NOISE = '.hx-delivery-date__day, .hx-delivery-date__left, .hx-ship-countdown, hermex-promo-hero [data-progress]';
  function hxIsNoise(m) {
    const el = m.target.nodeType === 1 ? m.target : m.target.parentElement;
    if (!el || !el.closest) return true;
    if (el === document.head || el.closest('head')) return true;
    return !!el.closest(HX_NOISE);
  }
  function hxRelevant(records) {
    if (!records) return true;
    for (let i = 0; i < records.length; i++) if (!hxIsNoise(records[i])) return true;
    return false;
  }
  // Nur für den Filter-Knopf der Handy-Leiste: Stil-/Klassenänderungen zählen nur an <html>, <body>
  // oder an Boost-Elementen (z. B. öffnet Boost das Filterfenster); neue/entfernte Elemente zählen immer.
  function hxBoostRelevant(records) {
    for (let i = 0; i < records.length; i++) {
      const m = records[i];
      if (hxIsNoise(m)) continue;
      if (m.type !== 'attributes') return true;
      const el = m.target;
      if (el === document.documentElement || el === document.body) return true;
      if (typeof el.className === 'string' && el.className.indexOf('boost-sd') !== -1) return true;
      if (el.closest && el.closest('[class*="boost-sd"], .hx-boost-drawer')) return true;
    }
    return false;
  }

  function onReady(callback) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', callback);
    } else {
      callback();
    }
  }

  // Ladezeit (Tan 2026-11-02): Offen-Zustände als Klasse statt :has() in custom-main.css.
  // Offene Finder-Liste: <html> bekommt hx-ttt-open (dunkler Hintergrund), ihre Section hx-ttt-host (liegt darüber).
  function hxTttOpenState() {
    const openLists = [...document.querySelectorAll('.hx-ttt-select.is-open')];
    document.documentElement.classList.toggle('hx-ttt-open', openLists.length > 0);
    const hosts = openLists.map(function (el) { return el.closest('.shopify-section'); });
    document.querySelectorAll('.shopify-section.hx-ttt-host').forEach(function (sec) {
      if (hosts.indexOf(sec) === -1) sec.classList.remove('hx-ttt-host');
    });
    hosts.forEach(function (sec) { if (sec) sec.classList.add('hx-ttt-host'); });
  }
  // Offener Warenkorb-Drawer: <html> bekommt hx-cart-open (Überlagerung ganz oben).
  // Beobachtet wird nur das Attribut "open", das kostet praktisch keine Rechenzeit.
  function initCartOpenState() {
    const sync = function () {
      const open = !!document.querySelector('cart-drawer#cart-drawer[open]');
      if (document.documentElement.classList.contains('hx-cart-open') !== open) {
        document.documentElement.classList.toggle('hx-cart-open', open);
      }
    };
    sync();
    new MutationObserver(sync).observe(document.body, { subtree: true, attributes: true, attributeFilter: ['open'] });
  }

  function onWindowLoad(callback) {
    if (document.readyState === 'complete') {
      callback();
    } else {
      window.addEventListener('load', callback);
    }
  }

  function setTextFromData(button, isExpanded) {
    const text = isExpanded ? button.getAttribute('data-show-less') : button.getAttribute('data-show-more');

    if (text) {
      button.textContent = text;
    }
  }

  function initProductDescriptionToggles() {
    [
      ['toggleDescription', 'productDescription'],
      ['toggleSpecifications', 'productSpecifications']
    ].forEach(function (pair) {
      const button = document.getElementById(pair[0]);
      const content = document.getElementById(pair[1]);

      if (!button || !content) return;

      button.addEventListener('click', function () {
        const isExpanded = content.classList.toggle('expanded');
        setTextFromData(button, isExpanded);
      });
    });
  }

  window.opencustomPolicyModal = function (contentId) {
    const pages = {
      termsOfService: {
        url: '/policies/terms-of-service',
        title: 'AGB'
      },
      privacyPolicy: {
        url: '/policies/privacy-policy',
        title: 'Datenschutzerklärung'
      }
    };

    const page = pages[contentId];
    if (!page) return;

    fetch(page.url)
      .then(function (response) {
        if (!response.ok) {
          throw new Error('Policy konnte nicht geladen werden.');
        }

        return response.text();
      })
      .then(function (html) {
        const parser = new DOMParser();
        const doc = parser.parseFromString(html, 'text/html');
        const content = doc.querySelector('#main-content');
        const modalContent = document.getElementById('custompolicymodalContent');
        const modalTitle = document.getElementById('modalTitle');
        const modal = document.getElementById('custompolicymodal');

        if (!content || !modalContent || !modalTitle || !modal) return;

        modalContent.innerHTML = content.innerHTML;
        modalTitle.innerText = page.title;
        modal.style.display = 'block';
      })
      .catch(function (error) {
        console.warn('Policy konnte nicht geladen werden:', error);
      });
  };

  window.closecustompolicyModal = function () {
    const modal = document.getElementById('custompolicymodal');

    if (modal) {
      modal.style.display = 'none';
    }
  };

  function initPolicyModalClose() {
    document.addEventListener('click', function (event) {
      const modal = document.getElementById('custompolicymodal');

      if (modal && modal.style.display === 'block' && event.target === modal) {
        window.closecustompolicyModal();
      }
    });
  }

  function initUmschaltseite() {
    if (window.location.pathname !== '/pages/umschaltseite') return;

    ['.header', '.announcement', '.footer'].forEach(function (selector) {
      const element = document.querySelector(selector);

      if (element) {
        element.style.display = 'none';
      }
    });
  }

  window.kopiereLink = function () {
    const url = window.location.href;

    function copyFallback() {
      const tempInput = document.createElement('input');
      tempInput.value = url;
      tempInput.setAttribute('readonly', 'readonly');
      tempInput.style.position = 'absolute';
      tempInput.style.left = '-9999px';
      document.body.appendChild(tempInput);
      tempInput.select();
      document.execCommand('copy');
      document.body.removeChild(tempInput);
      alert('Link kopiert: ' + url);
    }

    if (navigator.clipboard && window.isSecureContext) {
      navigator.clipboard.writeText(url)
        .then(function () {
          alert('Link kopiert: ' + url);
        })
        .catch(copyFallback);
    } else {
      copyFallback();
    }
  };

  function initPrinterModelSearch() {
    const searchInput = document.getElementById('printerModelSearch');
    const models = document.querySelectorAll('.grid-item-printerlist');

    if (!searchInput || !models.length) return;

    searchInput.addEventListener('input', function (event) {
      const searchText = event.target.value.toLowerCase();

      models.forEach(function (model) {
        const modelName = model.textContent.toLowerCase();
        model.style.display = modelName.includes(searchText) ? '' : 'none';
      });
    });
  }

  function hideReturnButtons() {
    ['breadcrumbReturnButton', 'customReturnButton'].forEach(function (id) {
      const button = document.getElementById(id);

      if (button) {
        button.classList.add('hidden');
      }
    });
  }

  function initFirstVisitReturnButtons() {
    try {
      if (!sessionStorage.getItem('firstPageVisited')) {
        sessionStorage.setItem('firstPageVisited', 'true');
        hideReturnButtons();
      }
    } catch (error) {
      hideReturnButtons();
    }
  }

  window.goBack = function () {
    window.history.back();
  };

  function initMissionStatementToggle() {
    const toggleButton = document.querySelector('.toggle-button');
    const content = document.querySelector('.content-collapsible');

    if (!toggleButton || !content) return;

    toggleButton.addEventListener('click', function () {
      const isExpanded = content.classList.contains('content-expanded');
      content.classList.toggle('content-expanded');
      setTextFromData(toggleButton, !isExpanded);
    });
  }

  function setStickyHeaderPosition() {
    const headerLogo = document.querySelector('.header__logo');
    const stickyHeader = document.querySelector('.cc-header--sticky');

    if (!headerLogo || !stickyHeader) return;

    if (window.innerWidth <= 767) {
      stickyHeader.style.top = '-' + (headerLogo.clientHeight + 11) + 'px';
    } else {
      stickyHeader.style.top = '-1px';
    }
  }

  function initStickyHeaderPosition() {
    setStickyHeaderPosition();
    window.addEventListener('resize', setStickyHeaderPosition);
  }

  // Haftende Boost-Sortierleiste (Kategorieseiten, Tan 2026-10-28): Abstand oben = Unterkante des
  // tatsächlich sichtbaren Headers, laufend gemessen. Die Theme-Variable --header-end blieb auf dem
  // Handy nach dem Ausblenden des Headers stehen, dadurch klebte die Leiste mitten im Bild.
  function initBoostToolbarTop() {
    let queued = false;
    const measure = function () {
      queued = false;
      const header = document.querySelector('store-header') || document.querySelector('.cc-header--sticky');
      let bottom = 0;
      if (header) {
        const rect = header.getBoundingClientRect();
        bottom = Math.max(0, Math.round(rect.bottom));
        if (bottom > window.innerHeight / 2) bottom = 0;
      }
      document.documentElement.style.setProperty('--hx-toolbar-top', bottom + 'px');
      // Schatten unter der Leiste nur, solange sie oben haftet; in Ruhe keine graue Linie (Tan 2026-10-28)
      document.querySelectorAll('.boost-sd__toolbar-container').forEach(function (bar) {
        const top = bar.getBoundingClientRect().top;
        bar.classList.toggle('hx-toolbar-stuck', window.scrollY > 0 && top <= bottom + 1 && top >= bottom - 8);
      });
    };
    const queue = function () {
      if (queued) return;
      queued = true;
      requestAnimationFrame(measure);
    };
    let settle;
    window.addEventListener('scroll', function () {
      queue();
      // Der Header gleitet nach dem Scrollen noch ein- oder aus: danach nochmals messen
      clearTimeout(settle);
      settle = setTimeout(queue, 450);
    }, { passive: true });
    window.addEventListener('resize', queue);
    document.addEventListener('transitionend', function (e) {
      if (e.target.closest && e.target.closest('.cc-header--sticky, store-header')) queue();
    });
    measure();
  }

  function updateBoostToolbarBreadcrumbState() {
    const toolbar = document.querySelector('.boost-sd__toolbar-top-mobile');
    if (!toolbar) return;

    toolbar.classList.toggle('with-breadcrumb', Boolean(document.querySelector('nav.breadcrumb')));
  }

  function initBoostToolbarBreadcrumbState() {
    updateBoostToolbarBreadcrumbState();
    setTimeout(updateBoostToolbarBreadcrumbState, 500);
    setTimeout(updateBoostToolbarBreadcrumbState, 1500);
  }

  function checkAndShowTimer() {
    const element = document.querySelector('.additionalcutofftimer');
    if (!element) return;

    const showTimer = new Date().getHours() === 16;
    element.style.setProperty('display', showTimer ? 'block' : 'none', 'important');
  }

  function initShippingCutoffTimer() {
    checkAndShowTimer();
    setInterval(checkAndShowTimer, 60000);
  }

  function initShippingPopup() {
    const popup = document.getElementById('shipping-popup');
    const trigger = document.querySelector('.shipping-cost-info .icon-shipcost');
    const closeBtn = document.querySelector('.close-popup');

    if (!popup) return;

    if (trigger) {
      trigger.addEventListener('click', function () {
        const rows = popup.querySelectorAll('table tr');

        rows.forEach(function (row) {
          row.classList.remove('active', 'strikethrough');
        });

        function addClassToRow(index, className) {
          if (rows[index]) {
            rows[index].classList.add(className);
          }
        }

        if (trigger.getAttribute('data-active-class1') === 'active') {
          addClassToRow(1, 'active');
        } else if (trigger.getAttribute('data-active-class2') === 'active') {
          addClassToRow(1, 'strikethrough');
          addClassToRow(2, 'active');
        } else if (trigger.getAttribute('data-active-class3') === 'active') {
          addClassToRow(1, 'strikethrough');
          addClassToRow(2, 'strikethrough');
          addClassToRow(3, 'active');
        } else if (trigger.getAttribute('data-active-class4') === 'active') {
          addClassToRow(1, 'strikethrough');
          addClassToRow(2, 'strikethrough');
          addClassToRow(3, 'strikethrough');
          addClassToRow(4, 'active');
        }

        popup.style.display = 'block';
      });
    }

    if (closeBtn) {
      closeBtn.addEventListener('click', function () {
        popup.style.display = 'none';
      });
    }

    window.addEventListener('click', function (event) {
      if (event.target === popup) {
        popup.style.display = 'none';
      }
    });
  }

  function initCookieBannerAutoAccept() {
    setTimeout(function () {
      const acceptButton = document.getElementById('shopify-pc__banner__btn-accept');

      if (acceptButton) {
        acceptButton.click();
      }
    }, 3000);
  }

  function initPrinterLinks() {
    const printerLinks = document.querySelectorAll('.printer-link');
    if (!printerLinks.length) return;

    function addClickListener(link) {
      if (!link || link.dataset.listenerAttached === 'true') return;

      link.dataset.listenerAttached = 'true';
      link.addEventListener('click', function (event) {
        event.preventDefault();

        const url = link.getAttribute('data-url');
        const parent = link.parentElement;

        if (!url || !parent) return;

        const existingLottie = parent.querySelector('.lottie-container');
        if (existingLottie) {
          existingLottie.remove();
        }

        fetch(url, { method: 'HEAD' })
          .then(function (response) {
            if (response.ok) {
              window.location.href = url;
            } else {
              showLottieAnimation(parent, link.innerText, url);
            }
          })
          .catch(function (error) {
            console.error('Fehler beim Prüfen des Printer-Links:', error);
            showLottieAnimation(parent, link.innerText, url);
          });
      });
    }

    function showLottieAnimation(parent, modelText, url) {
      const container = document.createElement('div');
      const animation = document.createElement('dotlottie-player');
      const text = document.createElement('span');

      container.className = 'lottie-container';
      animation.setAttribute('src', 'https://lottie.host/6757bebf-3c94-4cb5-973e-653ed9b4d3d5/mbePZH8Gb8.json');
      animation.setAttribute('background', 'transparent');
      animation.setAttribute('speed', '1');
      animation.setAttribute('style', 'width: 20px; height: 20px;');
      animation.setAttribute('loop', 'false');
      animation.setAttribute('autoplay', '');
      text.textContent = 'Garantiert Kompatibel';
      text.style.marginLeft = '8px';

      container.appendChild(animation);
      container.appendChild(text);
      parent.replaceChildren(container);

      setTimeout(function () {
        const newLink = document.createElement('a');
        newLink.href = '#';
        newLink.dataset.url = url;
        newLink.className = 'printer-link';
        newLink.textContent = modelText;
        parent.replaceChildren(newLink);
        addClickListener(newLink);
      }, 3500);
    }

    printerLinks.forEach(addClickListener);
  }

  function checkRivoPointsPurchases() {
    if (!window.RivoJS || typeof window.RivoJS.getCustomerPointsPurchases !== 'function') return;

    window.RivoJS.getCustomerPointsPurchases({ used: false })
      .then(function (resp) {
        const sectionToHide = document.getElementById('shopify-block-rivo_loyalty_referrals_lp_customer_account_UpRbda');
        const sectionToAdjust = document.getElementById('shopify-block-rivo_loyalty_referrals_lp_customer_account_mLbWJw');

        if (resp.success && Array.isArray(resp.points_purchases) && resp.points_purchases.length === 0) {
          if (sectionToHide) {
            sectionToHide.style.display = 'none';
          }

          if (sectionToAdjust) {
            sectionToAdjust.style.marginTop = '30px';
          }
        } else {
          if (sectionToHide) {
            sectionToHide.style.display = '';
          }

          if (sectionToAdjust) {
            sectionToAdjust.style.marginTop = '0';
          }
        }
      })
      .catch(function (error) {
        console.error('Fehler beim Aufruf der Rivo API:', error);
      });
  }

  function initRivoCheck() {
    if (window.RivoJS && typeof window.RivoJS.getCustomerPointsPurchases === 'function') {
      checkRivoPointsPurchases();
    } else {
      document.addEventListener('rivo-js-loaded', checkRivoPointsPurchases, { once: true });
    }
  }

  // Ganze Franken als "115.–" statt "115⁰⁰". Fängt auch Preise ab, die Boost (Filter, Suche)
  // serverseitig oder per JS rendert und nachlädt.
  function formatWholePrices() {
    // Boost (React) besitzt diese Knoten: nicht ersetzen, sondern nur Text ändern bzw. ausblenden.
    // Ersetzte Knoten bringen React beim nächsten Neuzeichnen durcheinander, die Karte wird
    // neu aufgebaut und flackert (Tan 2026-10-26, "229.–").
    document.querySelectorAll('sup').forEach(function (sup) {
      const before = sup.previousSibling;
      if (sup.dataset.hxWhole || sup.textContent.trim() !== '00' || !before || !/\d\s*$/.test(before.textContent)) return;
      const dash = document.createElement('span');
      dash.className = 'price-whole-dash';
      dash.textContent = '.–';
      sup.dataset.hxWhole = 'true';
      sup.style.display = 'none';
      sup.after(dash);
    });
    document.querySelectorAll('.boost-sd__format-currency span').forEach(function (el) {
      const text = el.firstChild;
      if (el.childNodes.length === 1 && text.nodeType === 3 && /\d\.00\s*$/.test(text.nodeValue)) {
        text.nodeValue = text.nodeValue.replace(/\.00(\s*)$/, '.–$1');
      }
    });
  }

  // Preis in Franken aus einem Preis-Element lesen ("137.–", "46<sup>95</sup>", "1'137.00")
  function readChf(el) {
    const sup = el.querySelector('sup');
    let text = el.textContent;
    let cents = 0;
    if (sup) {
      cents = parseInt(sup.textContent, 10) || 0;
      text = text.replace(sup.textContent, '');
    }
    const match = text.replace(/['’\s]/g, '').match(/\d+(\.\d{2})?/);
    return match ? parseFloat(match[0]) + cents / 100 : null;
  }

  // "Nur noch 7 Stück am Lager" -> "Nur noch 7 Stück" (Tan 2026-10-26).
  // Boost setzt geänderten Text beim Neuzeichnen zurück; ein wechselnd langer Text machte die Karte
  // abwechselnd breiter/schmaler und liess sie flackern. Darum bleibt Boosts Text unverändert und der
  // kurze Text kommt nur per CSS (data-hx-short). Ein eigener Beobachter setzt das Attribut sofort neu,
  // wenn Boost die Zeile neu zeichnet (auch innerhalb unserer umgebauten Bereiche).
  // Leerzeichen können geschützt sein (&nbsp;), und der Text kann in mehreren Unterelementen stecken.
  // Das Attribut kommt auf das innerste Element, das den ganzen Text enthält.
  const STOCK_LONG = /^Nur noch\s+\d+\s+Stück\s+am\s+Lager$/;
  function shortenStock(el) {
    const text = el.textContent.replace(/\s+/g, ' ').trim();
    if (!STOCK_LONG.test(text)) return;
    if ([...el.children].some(function (child) { return STOCK_LONG.test(child.textContent.replace(/\s+/g, ' ').trim()); })) return;
    if (el.closest('.hx-card-shipping, .hx-card-saving, .hx-card-extra')) return;
    const short = text.replace(/ am Lager$/, '');
    if (el.dataset.hxShort === short) return;
    el.style.setProperty('--hx-short-size', getComputedStyle(el).fontSize);
    el.dataset.hxShort = short;
  }
  function shortenStockTexts(root) {
    root.querySelectorAll('.boost-sd__product-item span, .boost-sd__product-item p, .boost-sd__product-item div, .boost-sd__product-item [class*="inventory"]').forEach(shortenStock);
  }
  function watchStockTexts() {
    new MutationObserver(function (mutations) {
      mutations.forEach(function (m) {
        const el = m.target.nodeType === 3 ? m.target.parentElement : m.target;
        if (!el || !el.closest || !el.closest('.boost-sd__product-item')) return;
        shortenStock(el);
        if (el.querySelectorAll) el.querySelectorAll('span, p, div').forEach(shortenStock);
      });
    }).observe(document.body, { childList: true, subtree: true, characterData: true });
  }

  // Kategorieseiten (Boost): Preis rechts neben "Auf Lager", darunter die Versandersparnis
  // ab CHF 50 bzw. 98 mit demselben grünen Symbol wie "Auf Lager".
  function layoutBoostCards() {
    // Boost-Toolbar (Handy und Desktop): "50 products" -> "50 Produkte" (Tan 2026-10-28)
    document.querySelectorAll('[class*="boost-sd__"][class*="product-count"]').forEach(function (box) {
      const walker = document.createTreeWalker(box, NodeFilter.SHOW_TEXT);
      while (walker.nextNode()) {
        const n = walker.currentNode;
        const fixed = n.nodeValue.replace(/\bproducts?\b/i, function (w) { return /s$/i.test(w) ? 'Produkte' : 'Produkt'; });
        if (fixed !== n.nodeValue) n.nodeValue = fixed;
      }
    });
    // Sortierliste: Grammatik "Niedrige Preis zuerst" -> "Niedrigster Preis zuerst" (Tan 2026-10-28)
    document.querySelectorAll('[class*="boost-sd__sorting"]').forEach(function (box) {
      const walker = document.createTreeWalker(box, NodeFilter.SHOW_TEXT);
      while (walker.nextNode()) {
        const n = walker.currentNode;
        if (n.nodeValue.indexOf('Niedrige Preis') !== -1) n.nodeValue = n.nodeValue.replace('Niedrige Preis', 'Niedrigster Preis');
      }
    });
    // "Nur noch 1 Stück am Lager" -> "Nur noch 1 Stück"
    shortenStockTexts(document);
    // Lagerpunkt (Tan 2026-10-30): nur "Auf Lager"/"Sofort Lieferbar" grün, alles andere orange (CSS in custom-main.css).
    // Bei jedem Durchlauf neu, weil Boost die Elemente beim Neuzeichnen weiterverwendet.
    document.querySelectorAll('.boost-sd__product-item .boost-sd__inventory-status').forEach(function (el) {
      const text = el.textContent.replace(/\s+/g, ' ').trim();
      // Kopien in Gratisversand/Preisvorteil-Zeilen bleiben grün (Tan 2026-10-30)
      const out = text !== '' && !el.closest('.hx-card-shipping, .hx-card-saving, .hx-card-extra')
        && !/^(Auf Lager|Sofort Lieferbar|Ausverkauft)/.test(text);
      if (out !== el.hasAttribute('data-hx-stock-out')) el.toggleAttribute('data-hx-stock-out', out);
    });
    document.querySelectorAll('.boost-sd__product-item:not([data-hx-card])').forEach(function (card) {
      const price = card.querySelector('.boost-sd__product-price')
        || card.querySelector('.boost-sd__format-currency');
      const stock = card.querySelector('.boost-sd__inventory-status')
        || [...card.querySelectorAll('span, p, div')].find(function (el) {
          return el.children.length === 0 && /^(Auf Lager|Sofort Lieferbar|Nur noch|Lieferzeit|Auf Nachbestellung)/.test(el.textContent.trim());
        });
      if (!price || !stock) return;
      card.dataset.hxCard = 'true';

      // Ganze Zeile von "Auf Lager" inkl. Punkt, aber ohne den Preis
      const stockText = stock.textContent.trim();
      let line = stock;
      while (line.parentElement && line.parentElement !== card
        && line.parentElement.textContent.trim() === stockText) {
        line = line.parentElement;
      }

      // Grün an Lager immer #00a92b (Farbkonzept Hermex)
      const inStock = /^(Auf Lager|Sofort Lieferbar|Nur noch)/.test(stockText);
      if (inStock) {
        line.style.color = '#00a92b';
        stock.style.color = '#00a92b';
      }

      const row = document.createElement('div');
      row.className = 'hx-stock-price';
      line.before(row);
      row.append(line, price);

      // Zusätzliche Zeile im Stil von "Auf Lager": grüner Punkt, #00a92b, gleiche Schriftgrösse.
      // Ohne Text bleibt sie unsichtbar stehen, damit alle Karten gleich hoch ausgerichtet sind.
      const greenLine = function (className) {
        const el = line.cloneNode(true);
        el.removeAttribute('id');
        // Der Kurztext (data-hx-short) gehört nur zur Lagerzeile, nicht zu den Kopien
        [el, ...el.querySelectorAll('[data-hx-short]')].forEach(function (n) {
          if (!n.dataset || !n.dataset.hxShort) return;
          delete n.dataset.hxShort;
          n.style.removeProperty('--hx-short-size');
        });
        el.classList.add(className);
        el.style.color = '#00a92b';
        const walker = document.createTreeWalker(el, NodeFilter.SHOW_TEXT);
        while (walker.nextNode()) {
          if (walker.currentNode.nodeValue.trim() === stockText) {
            walker.currentNode.parentElement.style.color = '#00a92b';
            const shortEl = stock.closest('[data-hx-short]') || stock.querySelector('[data-hx-short]');
            walker.currentNode.parentElement.style.fontSize = shortEl
              ? shortEl.style.getPropertyValue('--hx-short-size') || '13px'
              : getComputedStyle(stock).fontSize;
            el.hxText = walker.currentNode;
            break;
          }
        }
        return el;
      };

      const info = greenLine('hx-card-shipping');
      const saving = greenLine('hx-card-saving');
      const extra = greenLine('hx-card-extra');
      const below = document.createElement('div');
      below.className = 'hx-price-below';
      row.after(info);
      info.after(saving);
      saving.after(extra);
      extra.after(below);
      card.hxParts = { row: row, price: price, info: info, saving: saving, extra: extra, below: below };
    });

    // Texte und Preisposition bei jedem Durchlauf neu setzen, weil Boost Preise nachträglich rendern kann
    updateBoostCards(document.querySelectorAll('.boost-sd__product-item[data-hx-card]'));
  }

  // Versandzeilen auf allen Karten: Warenwert = Warenkorb + Preis des Artikels
  // (leerer Warenkorb = nur der Artikel). Ab CHF 50 "CHF 2.– Versand gespart",
  // ab CHF 98 "Gratisversand · CHF 7.90 gespart" (wie auf der Artikelseite).
  // Ein Preisvorteil folgt als nächste Zeile; die ersten zwei Zeilen bleiben immer reserviert.
  const SHIP_TIER1_MIN = 5000;
  const SHIP_FREE_MIN = 9800;
  let hxCartTotal = 0;
  // "Gratisversand" grün, "· CHF 7.90 gespart" schwarz (Tan 2026-10-23)
  // Auf Kategorieseiten steht die Ersparnis in Klammern in einer eigenen Zeile unter "Gratisversand"
  const IS_COLLECTION = /^\/collections\//.test(location.pathname);
  const FREE_PREFIX = 'Gratisversand ';
  const FREE_SUFFIX = IS_COLLECTION ? '(CHF 7.90 gespart)' : '· CHF 7.90 gespart';
  // Zweite Zeile genau unter dem Wort "Gratisversand" beginnen lassen (nicht unter dem Punkt)
  // Ladezeit (Tan 2026-11-02): Ausrichtung gebündelt. Vorher wurde jede Karte einzeln gemessen
  // (Stil setzen, messen, Stil setzen), was die Seite für jede Karte neu berechnen liess.
  // Jetzt werden alle Karten gesammelt und gemeinsam in vier Schritten ausgerichtet; das Ergebnis ist gleich.
  const hxAlignQueue = new Map();
  let hxAlignQueued = false;
  // Nach dem Laden der Schrift oder bei neuer Fensterbreite alles neu ausrichten
  let hxAlignGen = 0;
  if (document.fonts && document.fonts.ready) document.fonts.ready.then(function () { hxAlignGen++; });
  let hxAlignWidth = window.innerWidth;
  window.addEventListener('resize', function () { if (window.innerWidth !== hxAlignWidth) { hxAlignWidth = window.innerWidth; hxAlignGen++; } });
  function alignBlack(black, textNode) {
    if (!black || !textNode) return;
    hxAlignQueue.set(black, textNode);
    if (hxAlignQueued) return;
    hxAlignQueued = true;
    queueMicrotask(flushAlignBlack);
  }
  function flushAlignBlack() {
    hxAlignQueued = false;
    if (!hxAlignQueue.size) return;
    const items = [];
    hxAlignQueue.forEach(function (textNode, black) {
      if (black.isConnected && textNode.isConnected && black.parentNode) items.push([black, textNode]);
    });
    hxAlignQueue.clear();
    // 1. Lesen: Ist die Zeile ein Flex-Container? Karten, deren Text und Breite sich seit der letzten
    // Ausrichtung nicht geändert haben, bleiben wie sie sind (spart die Neuberechnung bei jedem Durchlauf).
    const keys = items.map(function (it) {
      return [it[1].nodeValue, it[0].textContent, it[0].parentNode.clientWidth, hxAlignGen].join('|');
    });
    for (let i = items.length - 1; i >= 0; i--) {
      if (items[i][0].hxAlignKey === keys[i]) { items.splice(i, 1); keys.splice(i, 1); }
    }
    if (!items.length) return;
    items.forEach(function (it, i) { it[0].hxAlignKey = keys[i]; });
    const flex = items.map(function (it) { return getComputedStyle(it[0].parentNode).display.indexOf('flex') !== -1; });
    // 2. Schreiben: Grundzustand
    items.forEach(function (it, i) {
      const black = it[0];
      if (!IS_COLLECTION) {
        // Andere Seiten (z. B. Empfehlungen im Warenkorb): Ist die Zeile ein Flex-Container, würden
        // "Gratisversand" und "· CHF 7.90 gespart" als zwei schmale Spalten mitten im Wort umbrechen.
        // Deshalb ganze Wörter behalten und den schwarzen Teil bei Platzmangel in die nächste Zeile setzen.
        if (!flex[i]) return;
        black.parentNode.style.flexWrap = 'wrap';
        black.style.whiteSpace = 'nowrap';
        black.style.marginInlineStart = '0.25em';
        return;
      }
      black.style.display = 'block';
      // Die Zeile ist ein Flex-Container (Punkt + Text): umbrechen lassen, Klammer-Text als volle zweite Zeile
      if (flex[i]) {
        black.parentNode.style.flexWrap = 'wrap';
        black.style.flex = '0 0 100%';
      }
      black.style.marginInlineStart = '0px';
    });
    // 3. Lesen: Positionen (eine Berechnung für alle Karten)
    const rects = items.map(function (it, i) {
      if (!IS_COLLECTION && !flex[i]) return null;
      const range = document.createRange();
      range.selectNodeContents(it[1]);
      return [range.getBoundingClientRect(), it[0].getBoundingClientRect()];
    });
    // 4. Schreiben: Zweite Zeile genau unter dem Wort "Gratisversand" beginnen lassen
    items.forEach(function (it, i) {
      const r = rects[i];
      if (!r) return;
      const black = it[0];
      const textRect = r[0];
      const blackRect = r[1];
      if (!IS_COLLECTION) {
        if (blackRect.top >= textRect.bottom - 2 && textRect.left > blackRect.left) {
          black.style.marginInlineStart = `${Math.round(textRect.left - blackRect.left)}px`;
        }
        return;
      }
      if (textRect.left > blackRect.left) {
        const offset = Math.round(textRect.left - blackRect.left);
        black.style.marginInlineStart = `${offset}px`;
        if (black.style.flex) black.style.flex = `0 0 calc(100% - ${offset}px)`;
      }
    });
  }
  function splitBlack(text) {
    return text && text.indexOf(FREE_PREFIX + FREE_SUFFIX) === 0 ? [FREE_PREFIX, FREE_SUFFIX] : [text, ''];
  }
  function shippingLines(priceCents, savingText) {
    const value = hxCartTotal + priceCents;
    let lines = [];
    if (value >= SHIP_FREE_MIN) lines = [FREE_PREFIX + FREE_SUFFIX];
    else if (value >= SHIP_TIER1_MIN) lines = ['CHF 2.– Versand gespart'];
    if (savingText) lines.push(savingText);
    return lines;
  }

  function setThemeLine(el, text) {
    const value = text || '\u00a0';
    const parts = splitBlack(text);
    const black = el.querySelector('.hx-black');
    if (el.textContent !== value || !!black !== !!parts[1]) {
      el.textContent = parts[1] ? parts[0] : value;
      if (parts[1]) {
        const span = document.createElement('span');
        span.className = 'hx-black';
        span.textContent = parts[1];
        el.appendChild(span);
      }
    }
    if (parts[1]) alignBlack(el.querySelector('.hx-black'), el.firstChild);
    el.style.visibility = text ? '' : 'hidden';
    if (text) el.removeAttribute('aria-hidden'); else el.setAttribute('aria-hidden', 'true');
    // Leere Platzhalter aus Liquid haben kein in_stock und wären sonst schwarz statt grün
    el.dataset.inventoryLevel = 'in_stock';
  }

  // Theme-Karten (snippets/product-card-hx.liquid): Liquid rechnet nur mit dem Artikel,
  // hier kommt der Warenkorb dazu. Der Preisvorteil wird beim ersten Mal aus den Liquid-Zeilen gelesen.
  function updateThemeCards() {
    document.querySelectorAll('.hx-card-shipping[data-hx-price]').forEach(function (info) {
      if (info.closest('.boost-sd__product-item')) return;
      const saving = info.parentElement.querySelector('.hx-card-saving');
      if (!saving) return;
      if (info.dataset.hxSaving === undefined) {
        info.dataset.hxSaving = [info.textContent.trim(), saving.textContent.trim()]
          .find(function (t) { return /(dazu gespart|reduziert)$/.test(t); }) || '';
      }
      const available = info.dataset.hxAvailable !== 'false';
      const lines = available
        ? shippingLines(Number(info.dataset.hxPrice) || 0, info.dataset.hxSaving)
        : [info.dataset.hxSaving].filter(Boolean);
      setThemeLine(info, lines[0]);
      setThemeLine(saving, lines[1]);
      let extra = info.parentElement.querySelector('.hx-card-extra');
      if (lines[2]) {
        if (!extra) {
          extra = saving.cloneNode(true);
          extra.classList.remove('hx-card-saving');
          extra.classList.add('hx-card-extra');
          saving.after(extra);
        }
        setThemeLine(extra, lines[2]);
        extra.style.display = '';
      } else if (extra) {
        extra.style.display = 'none';
      }
    });
  }

  // Crossselling "Passend dazu" (snippets/cross-sell-product-hx.liquid): gleiche Versandzeilen, ohne Preisvorteil
  function updateCrossCards() {
    document.querySelectorAll('.hx-cross-shipping[data-hx-price]').forEach(function (box) {
      const lines = box.dataset.hxAvailable === 'false' ? [] : shippingLines(Number(box.dataset.hxPrice) || 0, '');
      const key = lines.join('|');
      if (box.dataset.hxLines === key) return;
      box.dataset.hxLines = key;
      box.textContent = '';
      lines.forEach(function (text) {
        const span = document.createElement('span');
        span.className = 'hx-dot';
        span.style.color = '#00a92b';
        const parts = splitBlack(text);
        span.textContent = parts[0];
        if (parts[1]) {
          const black = document.createElement('span');
          black.className = 'hx-black';
          black.textContent = parts[1];
          span.appendChild(black);
        }
        box.appendChild(span);
      });
    });
  }

  function refreshCartTotal() {
    fetch((window.Shopify && window.Shopify.routes && window.Shopify.routes.root || '/') + 'cart.js')
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (cart) {
        if (!cart) return;
        hxCartTotal = cart.total_price;
        updateThemeCards();
        updateCrossCards();
        updateBoostCards(document.querySelectorAll('.boost-sd__product-item[data-hx-card]'));
      })
      .catch(function () {});
  }

  function initCartFreeShipping() {
    refreshCartTotal();
    ['on:cart:add', 'on:line-item:change', 'on:cart:change', 'hx:cart-drawer:updated'].forEach(function (name) {
      document.addEventListener(name, function () { setTimeout(refreshCartTotal, 300); });
    });
    // Warenkorb-Änderungen per fetch (z. B. Boost, Warenkorb-Drawer)
    if (window.fetch) {
      const originalFetch = window.fetch;
      window.fetch = function (input) {
        const url = String(typeof input === 'string' ? input : (input && input.url) || '');
        const result = originalFetch.apply(this, arguments);
        if (/\/cart\/(add|change|update|clear)/.test(url)) {
          result.then(function () { setTimeout(refreshCartTotal, 300); }).catch(function () {});
        }
        return result;
      };
    }
  }

  // Kategorieseiten (Raster): Preise einer Reihe auf gleicher Höhe unten ausrichten (Handy Tan 2026-10-26,
  // Desktop/Tablet Tan 2026-10-28: Karten nur so hoch wie nötig, kein Leerraum unter den Infozeilen).
  // Karten nebeneinander werden gleich hoch; der Preisblock der kürzeren Karte rutscht um die Differenz nach unten.
  // Hat die Karte Farbfelder über dem Preis, rutschen diese mit (Abstand kommt über die Farbfelder).
  // Jeder Durchlauf setzt zuerst alle Zusatzabstände zurück, misst dann und schreibt neu (alles im selben Frame,
  // also ohne sichtbaren Sprung). So kann sich kein Abstand aufschaukeln (Tan 2026-10-26: grosse Lücken, Flackern).
  // Mehr als ALIGN_MAX px wird nie ausgeglichen: dann ist die Messung falsch (Bild/Text noch nicht geladen).
  const ALIGN_MAX = 120;
  function alignTarget(below) {
    const prev = below.previousElementSibling;
    return prev && prev.classList.contains('hx-swatches') && prev.offsetParent ? prev : below;
  }
  function alignBoostPrices() {
    const cards = [...document.querySelectorAll('.boost-sd__product-item[data-hx-card]')]
      .filter(function (card) { return card.hxParts && !card.closest('.boost-sd__product-list-list-col'); });
    if (!cards.length) return;
    const previous = cards.map(function (card) { return card.hxParts.below.dataset.hxAlign || ''; });
    cards.forEach(function (card) {
      const below = card.hxParts.below;
      below.style.removeProperty('margin-top');
      const prev = below.previousElementSibling;
      if (prev && prev.classList.contains('hx-swatches')) prev.style.removeProperty('margin-top');
    });
    const rows = {};
    const items = cards.map(function (card) {
      const below = card.hxParts.below;
      const target = alignTarget(below);
      const rect = below.getBoundingClientRect();
      // Messung relativ zur Karte (offsetTop): die beim Darüberfahren angehobene Karte (translateY)
      // bleibt so in derselben Reihe und verschiebt die Messung nicht (Tan 2026-10-28)
      const cardTop = card.getBoundingClientRect().top;
      const key = Math.round(card.offsetTop / 10);
      const bottom = rect.bottom - cardTop + card.offsetTop;
      if (rect.height) rows[key] = Math.max(rows[key] || 0, bottom);
      return { below: below, target: target, bottom: bottom, height: rect.height, key: key,
        base: parseFloat(getComputedStyle(target).marginTop) || 0 };
    });
    items.forEach(function (item, i) {
      let extra = item.height ? Math.round(rows[item.key] - item.bottom) : 0;
      if (extra < 1 || extra > ALIGN_MAX) extra = 0;
      if (extra) item.target.style.setProperty('margin-top', (item.base + extra) + 'px', 'important');
      if (String(extra || '') !== previous[i]) {
        if (extra) item.below.dataset.hxAlign = String(extra); else delete item.below.dataset.hxAlign;
      }
    });
  }

  // Leerer Bereich unter Preis und Icons halb so hoch (Kategorieseiten und Theme-Karten).
  // Der Abstand wird je Karte einmal gemessen und mit negativem Aussenabstand halbiert.
  function tightenCardBottoms() {
    document.querySelectorAll('.boost-sd__product-item[data-hx-card] .hx-price-below, .card--product .hx-price-below').forEach(function (below) {
      if (below.dataset.hxTight) return;
      const card = below.closest('.boost-sd__product-item, .card--product');
      if (!card) return;
      const cardRect = card.getBoundingClientRect();
      const belowRect = below.getBoundingClientRect();
      if (!cardRect.height || !belowRect.height) return;
      below.dataset.hxTight = 'true';
      const gap = cardRect.bottom - belowRect.bottom;
      if (gap > 4) below.style.marginBottom = `-${Math.round(gap / 2)}px`;
    });
  }

  // Kategorieseiten (Boost): statt des schwarzen Knopfs "In den Warenkorb" die zwei runden Icons
  // der Theme-Karten (Auge = Produktseite, Warenkorb) unten rechts neben dem Preis.
  // Die Boost-Knöpfe bleiben versteckt im DOM (React); das Warenkorb-Icon klickt den Boost-Knopf.
  const BOOST_BUTTONS = '[class*="btn-quick-view"], [class*="btn-add-to-cart"], [class*="btn-select-option"]';
  function findBoostCartButton(card) {
    return [...card.querySelectorAll(BOOST_BUTTONS)].find(function (el) {
      return !el.closest('.hx-quick-buttons') && !/quick-view/.test(el.getAttribute('class'));
    })
      // Listen-Ansicht: Boost-Knopf hat dort eine andere Klasse, darum zusätzlich über den Text suchen
      || [...card.querySelectorAll('button')].find(function (el) {
        return !el.closest('.hx-quick-buttons') && /^(In den Warenkorb|Add to cart)$/i.test(el.textContent.trim());
      })
      || null;
  }

  function quickIcon(name) {
    const tpl = document.getElementById('hx-quick-icons');
    const icon = tpl && tpl.content.querySelector('[data-icon="' + name + '"]');
    return icon ? icon.innerHTML : '';
  }

  // Artikel mit Varianten (Farbfelder bzw. Boost-Knopf "Optionen wählen") bekommen keine runden Knöpfe (Tan 2026-10-26)
  // Nur sichtbare Farbfelder zählen: Boost legt auch bei Artikeln ohne Varianten versteckte
  // Swatch-Elemente an, sonst verschwinden die Knöpfe auf allen Karten (Tan 2026-10-28)
  function hasVariants(card) {
    if (card.querySelector('[class*="btn-select-option"]')) return true;
    return [...card.querySelectorAll('[class*="swatch"]')].some(function (el) {
      return !el.closest('.hx-quick-buttons') && isVisible(el);
    });
  }

  function cartQuickButton(card) {
    const cart = document.createElement('button');
    cart.type = 'button';
    cart.className = 'hx-quick-btn';
    cart.title = 'In den Warenkorb';
    cart.setAttribute('aria-label', 'In den Warenkorb');
    cart.innerHTML = quickIcon('cart');
    cart.addEventListener('click', function (e) {
      e.preventDefault();
      e.stopPropagation();
      const original = findBoostCartButton(card);
      if (!original) return;
      original.click();
    });
    return cart;
  }

  function markBoostButtons(card) {
    card.querySelectorAll(BOOST_BUTTONS).forEach(function (el) {
      if (!el.closest('.hx-quick-buttons')) el.classList.add('hx-moved');
    });
  }
  // Desktop: Varianten-Artikel zeigen dort die Farbfelder und nur das Auge, ohne Warenkorb-Icon (Tan 2026-10-28).
  // Auf dem Handy sind die Farbfelder ausgeblendet, darum bekommen dort alle Karten Auge + Warenkorb;
  // der Warenkorb öffnet bei Varianten die Auswahl (Tan 2026-10-26)
  function boostEyeOnly(card) {
    // Ladezeit (Tan 2026-11-02): auf dem Handy gar nicht erst messen, das Ergebnis ist dort immer "nein"
    return !window.matchMedia('(max-width: 768px)').matches && hasVariants(card);
  }
  function placeBoostButtons(card, below, eyeOnly) {
    const existing = below.querySelector('.hx-quick-buttons');
    if (existing) {
      if (eyeOnly) {
        existing.querySelectorAll('button.hx-quick-btn').forEach(function (el) { el.remove(); });
      } else if (!existing.querySelector('button.hx-quick-btn') && findBoostCartButton(card)) {
        // Warenkorb-Icon nachträglich rechts vom Auge ergänzen, falls Boost den Knopf später gerendert hat
        existing.appendChild(cartQuickButton(card));
      }
      return;
    }
    const link = card.querySelector('a[href*="/products/"]');
    const box = document.createElement('div');
    box.className = 'hx-quick-buttons';
    if (link) {
      const view = document.createElement('a');
      view.className = 'hx-quick-btn';
      view.href = link.href;
      view.title = 'Details ansehen';
      view.setAttribute('aria-label', 'Details ansehen');
      view.innerHTML = quickIcon('view');
      view.addEventListener('click', function (e) { e.stopPropagation(); });
      box.appendChild(view);
    }
    if (!eyeOnly && findBoostCartButton(card)) box.appendChild(cartQuickButton(card));
    if (box.childElementCount) below.appendChild(box);
  }

  // Beim Darüberfahren das zweite Produktbild zeigen (Kategorieseiten über Boost).
  // Das Bild kommt aus /products/<handle>.js und wird erst beim ersten Hover geladen.
  // Boost (React) zeichnet Karten neu oder verwendet sie nach Filtern/Sortieren/Nachladen für ein anderes
  // Produkt weiter. Darum merkt sich jede Karte, für welches Produkt das Bild gilt, und prüft bei jedem
  // Hover, ob es noch da ist (sonst fehlte das Bild oder es zeigte das Bild eines anderen Produkts).
  const hoverImageCache = {};
  function boostCardHandle(card) {
    const link = card.querySelector('a[href*="/products/"]');
    const match = link && link.getAttribute('href').match(/\/products\/([^/?#]+)/);
    return match ? match[1] : null;
  }
  function boostSecondImage(handle) {
    if (!hoverImageCache[handle]) {
      hoverImageCache[handle] = fetch('/products/' + handle + '.js')
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (p) {
          if (!p || !p.images || p.images.length < 2) return null;
          const src = p.images[1];
          return src + (src.indexOf('?') === -1 ? '?' : '&') + 'width=600';
        })
        .catch(function () { return null; });
    }
    return hoverImageCache[handle];
  }

  function initBoostHoverImages() {
    if (!window.matchMedia('(hover: hover) and (pointer: fine)').matches) return;
    document.addEventListener('mouseover', function (e) {
      const card = e.target.closest && e.target.closest('.boost-sd__product-item');
      if (!card) return;
      const handle = boostCardHandle(card);
      if (!handle) return;
      const state = card.dataset.hxHover || '';
      const existing = card.querySelector('.hx-hover-image');
      if (state === handle + '|loading' || state === handle + '|none') return;
      if (state === handle + '|ready' && existing && existing.dataset.hxHandle === handle) return;
      if (existing) existing.remove();
      card.dataset.hxHover = handle + '|loading';
      boostSecondImage(handle).then(function (src) {
        // Inzwischen anderes Produkt in der Karte: beim nächsten Hover neu versuchen
        if (boostCardHandle(card) !== handle) { delete card.dataset.hxHover; return; }
        if (!src) { card.dataset.hxHover = handle + '|none'; return; }
        const img = card.querySelector('.boost-sd__product-image-img--main') || card.querySelector('.boost-sd__product-image img:not(.hx-hover-image)') || card.querySelector('img:not(.hx-hover-image)');
        if (!img || !img.parentElement) { delete card.dataset.hxHover; return; }
        const wrap = (img.closest('picture') || img).parentElement;
        if (getComputedStyle(wrap).position === 'static') wrap.style.position = 'relative';
        const old = card.querySelector('.hx-hover-image');
        if (old) old.remove();
        const second = document.createElement('img');
        second.className = 'hx-hover-image';
        second.dataset.hxHandle = handle;
        second.src = src;
        second.alt = '';
        wrap.appendChild(second);
        card.dataset.hxHover = handle + '|ready';
      });
    });
  }

  function setLine(el, text) {
    const parts = splitBlack(text);
    if (el.hxText) {
      el.hxText.nodeValue = parts[0] || '\u00a0';
      let black = el.hxText.parentNode.querySelector(':scope > .hx-black');
      if (parts[1] && !black) {
        black = document.createElement('span');
        black.className = 'hx-black';
        el.hxText.parentNode.insertBefore(black, el.hxText.nextSibling);
      }
      if (black) {
        if (black.textContent !== parts[1]) black.textContent = parts[1];
        black.style.display = parts[1] ? '' : 'none';
        if (parts[1]) alignBlack(black, el.hxText);
      }
    }
    el.style.visibility = text ? '' : 'hidden';
    el.classList.toggle('hx-empty', !text);
  }

  // Preis, Versandzeile und Sparzeile einer Boost-Karte aktualisieren.
  // Alle Preise der Karte werden gelesen: der tiefste ist der Verkaufspreis, der höchste der Streichpreis.
  function updateBoostCard(card) {
    const parts = card.hxParts;
    if (!parts) return false;
    const values = [...card.querySelectorAll('.boost-sd__format-currency')]
      .filter(function (el) { return !el.parentElement.closest('.boost-sd__format-currency'); })
      .map(readChf)
      .filter(function (v) { return v !== null && v > 0; });
    if (!values.length) return false;
    const value = Math.min.apply(null, values);
    const compareValue = Math.max.apply(null, values);
    const saved = Math.round((compareValue - value) * 100) / 100;

    const savedText = saved % 1 === 0 ? `${saved}.–` : saved.toFixed(2);
    const savingText = saved > 0 ? `CHF ${savedText} reduziert` : '';
    const lines = shippingLines(Math.round(value * 100), savingText);
    setLine(parts.info, lines[0]);
    setLine(parts.saving, lines[1]);
    // Dritte Zeile nur bei Bedarf, sonst ganz weg
    setLine(parts.extra, lines[2]);
    parts.extra.style.display = lines[2] ? '' : 'none';

    // Preis immer unter die grünen Zeilen (Kategorieseiten)
    if (parts.price.parentElement !== parts.below) parts.below.prepend(parts.price);
    return true;
  }

  // Ladezeit (Tan 2026-11-02): Mit echtem Boost lief die Prüfung "Farbfelder sichtbar?" zwischen
  // Schreibvorgängen, so dass der Browser die Seite für jede Karte neu berechnen musste (über 10 s
  // auf Tinten & Toner am Handy). Jetzt in drei Schritten für alle Karten: erst schreiben, dann
  // gesammelt messen, dann Knöpfe und Farbfelder setzen. Ergebnis wie vorher.
  function updateBoostCards(list) {
    const cards = [...list].filter(updateBoostCard);
    cards.forEach(markBoostButtons);
    const plan = cards.map(function (card) {
      return { eyeOnly: boostEyeOnly(card), swatches: findBoostSwatches(card) };
    });
    cards.forEach(function (card, i) {
      placeBoostButtons(card, card.hxParts.below, plan[i].eyeOnly);
      placeBoostSwatches(card, card.hxParts.below, plan[i].swatches);
    });
  }

  // Artikel mit Varianten: Die sichtbare Variantenauswahl (Bilder mit "+2") lag über dem Preis.
  // Sie kommt als eigene Zeile direkt über den Preis, Preis 6 px darunter (Tan 2026-10-26).
  // Nur sichtbare Elemente verschieben: Boost hat zusätzlich eine versteckte Auswahl ("Farbe"),
  // die versteckt bleiben muss.
  function isVisible(el) {
    return el.offsetWidth > 0 && el.offsetHeight > 0 && getComputedStyle(el).visibility !== 'hidden';
  }
  // Nur lesen: vorhandene oder neu gefundene sichtbare Variantenauswahl der Karte
  function findBoostSwatches(card) {
    let swatches = card.querySelector('.hx-swatches');
    if (!swatches) {
      const all = [...card.querySelectorAll('[class*="swatch"]')];
      const hidden = all.filter(function (el) { return !isVisible(el); });
      // Sichtbar und ohne versteckte Auswahl darin, damit diese nicht mitwandert
      const visible = all.filter(function (el) {
        return !el.closest('.hx-price-below') && isVisible(el)
          && !hidden.some(function (h) { return el.contains(h); });
      });
      swatches = visible.find(function (el) {
        return !visible.some(function (other) { return other !== el && other.contains(el); });
      });
    }
    return swatches || null;
  }
  function placeBoostSwatches(card, below, swatches) {
    if (!swatches) return;
    swatches.classList.add('hx-swatches');
    // Nur einmal verschieben: Stellt Boost die Auswahl beim Neuzeichnen zurück, nicht dagegen ankämpfen,
    // sonst springt die Karte im Wechsel hin und her und flackert (Tan 2026-10-26, Baby Balance Bike)
    if (swatches.nextElementSibling !== below) {
      if (swatches.dataset.hxMoved) return;
      swatches.dataset.hxMoved = 'true';
      below.before(swatches);
    }
    below.classList.add('hx-price-below--swatches');
  }

  // Flug-Animation zum Warenkorb auch auf Kategorieseiten (Boost): Sobald Boost einen Artikel
  // erfolgreich in den Warenkorb legt (/cart/add), fliegt das Bild der zuletzt angeklickten Karte.
  function initBoostFlyToCart() {
    let lastCard = null;
    let lastClick = 0;
    document.addEventListener('click', function (e) {
      const card = e.target.closest && e.target.closest('.boost-sd__product-item, .boost-sd__quick-view');
      if (!card) return;
      lastCard = card;
      lastClick = Date.now();
    }, true);
    const flyFromLastCard = function () {
      if (!lastCard || Date.now() - lastClick > 8000 || !window.hxFlyFrom) return;
      const card = lastCard;
      lastCard = null;
      const img = [...card.querySelectorAll('img:not(.hx-hover-image)')].find(function (el) {
        const r = el.getBoundingClientRect();
        return r.width > 0 && r.height > 0;
      });
      window.hxFlyFrom(img || card.querySelector('img:not(.hx-hover-image)'), card.querySelector('.hx-quick-buttons button') || card);
    };
    const isCartAdd = function (url) { return /\/cart\/add/.test(String(url || '')); };
    if (window.fetch) {
      const originalFetch = window.fetch;
      window.fetch = function (input) {
        const url = typeof input === 'string' ? input : (input && input.url);
        const result = originalFetch.apply(this, arguments);
        if (isCartAdd(url)) {
          result.then(function (r) { if (r && r.ok) flyFromLastCard(); }).catch(function () {});
        }
        return result;
      };
    }
    const originalOpen = XMLHttpRequest.prototype.open;
    XMLHttpRequest.prototype.open = function (method, url) {
      if (isCartAdd(url)) {
        this.addEventListener('load', function () { if (this.status >= 200 && this.status < 300) flyFromLastCard(); });
      }
      return originalOpen.apply(this, arguments);
    };
  }

  // Doofinder-Suche (Tan 2026-10-28): Die Doofinder-Karten zeigen dieselbe Karte wie die Kategorieseite
  // (Rabatt-Ecke, Sterne, Lagerstatus, Versandersparnis, Hermex-Preis, Auge/Warenkorb).
  // Die Karte kommt aus sections/hx-suchkarte.liquid, pro Artikel einmal geladen und gemerkt.
  // Die Doofinder-Inhalte bleiben versteckt im DOM, damit Doofinder weiter zählen und neu zeichnen kann.
  // Klappt das Laden nicht, bleibt die normale Doofinder-Karte stehen.
  const dfdCache = new Map();
  function dfdCardUrl(card) {
    const link = card.getAttribute('dfd-value-link')
      || (card.querySelector('a[href*="/products/"]') || {}).href || '';
    try {
      const url = new URL(link, location.origin);
      return /\/products\/[^/]+/.test(url.pathname) ? url.pathname.replace(/\/$/, '') : '';
    } catch (e) {
      return '';
    }
  }
  function dfdLoad(path) {
    if (!dfdCache.has(path)) {
      dfdCache.set(path, fetch(path + '?section_id=hx-suchkarte')
        .then(function (r) { return r.ok ? r.text() : ''; })
        .then(function (html) {
          const doc = new DOMParser().parseFromString(html, 'text/html');
          // Die Styles der Karte nur einmal in den Kopf der Seite
          doc.querySelectorAll('style').forEach(function (style) {
            if (!document.getElementById('hx-dfd-style')) {
              style.id = 'hx-dfd-style';
              document.head.appendChild(style);
            }
            style.remove();
          });
          const box = doc.querySelector('.hx-dfd-card');
          return box && box.querySelector('product-card') ? box.outerHTML : '';
        })
        .catch(function () { return ''; }));
    }
    return dfdCache.get(path);
  }
  // Ohne product-form.js schickt das Warenkorb-Icon das Formular ab und lädt die Seite neu
  function dfdFormScript(box) {
    const src = box && box.dataset.hxFormJs;
    if (!src || customElements.get('product-form') || document.querySelector('script[src*="product-form.js"]')) return;
    const script = document.createElement('script');
    script.src = src;
    script.defer = true;
    document.head.appendChild(script);
  }
  // Sortierliste: gewählte Option fett (Doofinder markiert sie selbst nicht)
  function markDoofinderSort() {
    const label = document.querySelector('.dfd-sort-label');
    if (!label) return;
    const current = label.textContent.trim();
    document.querySelectorAll('.dfd-sort-option-button').forEach(function (btn) {
      const selected = btn.textContent.trim() === current;
      if (btn.classList.contains('hx-selected') !== selected) btn.classList.toggle('hx-selected', selected);
    });
  }
  function layoutDoofinderCards() {
    markDoofinderSort();
    document.querySelectorAll('.dfd-card').forEach(function (card) {
      const path = dfdCardUrl(card);
      if (!path) return;
      if (card.dataset.hxDfd === path && card.querySelector(':scope > .hx-dfd-card')) return;
      card.dataset.hxDfd = path;
      dfdLoad(path).then(function (html) {
        if (!html || card.dataset.hxDfd !== path) return;
        const old = card.querySelector(':scope > .hx-dfd-card');
        if (old) old.remove();
        card.insertAdjacentHTML('beforeend', html);
        card.classList.add('hx-dfd');
        const box = card.querySelector(':scope > .hx-dfd-card');
        // Klicks auf Auge/Warenkorb nicht an Doofinder weitergeben (sonst öffnet Doofinder zusätzlich den Artikel)
        box.addEventListener('click', function (event) {
          if (event.target.closest('.quick-action-circle-btn, form')) event.stopPropagation();
        });
        dfdFormScript(box);
      });
    });
  }
  function dfdClose() {
    const close = document.querySelector('.dfd-btn-close, .dfd-close-button, [dfd-click="close-layer"]')
      || [...document.querySelectorAll('.dfd-layer button, .dfd-root button')].find(function (btn) {
        return /schlie|close/i.test((btn.getAttribute('aria-label') || '') + ' ' + btn.className);
      });
    if (close) close.click();
  }
  // Ist das Doofinder-Suchfenster offen? Dann html.hx-dfd-open (Handy: Leiste unten darüber, Filter-Knopf)
  function syncDoofinderOpen() {
    const layer = document.querySelector('.dfd-layer');
    const open = !!(layer && layer.getClientRects().length && getComputedStyle(layer).visibility !== 'hidden');
    const root = document.documentElement;
    if (root.classList.contains('hx-dfd-open') !== open) root.classList.toggle('hx-dfd-open', open);
    if (!open && root.classList.contains('hx-dfd-filter-open')) root.classList.remove('hx-dfd-filter-open');
    if (!open && root.classList.contains('hx-dfd-scrolled')) root.classList.remove('hx-dfd-scrolled');
    // Handy: Doofinders eigenes Filterfenster offen? Dann Filter-Knopf unten orange
    const nativeFilters = document.querySelector('.dfd-mobile .dfd-filters-layer');
    if (nativeFilters) {
      const filterOpen = open && !nativeFilters.classList.contains('hidden') && !!nativeFilters.getClientRects().length;
      if (root.classList.contains('hx-dfd-filter-open') !== filterOpen) root.classList.toggle('hx-dfd-filter-open', filterOpen);
    }
  }
  // Handy: Filter der Suche als eigenes Fenster über den Ergebnissen, mit Kopfzeile "Filter" und rotem X
  function dfdToggleFilter(show) {
    const root = document.documentElement;
    // Handy (.dfd-mobile): Doofinders eigenes Filterfenster öffnen/schliessen
    if (document.querySelector('.dfd-mobile')) {
      const layer = document.querySelector('.dfd-mobile .dfd-filters-layer');
      const isOpen = !!(layer && !layer.classList.contains('hidden') && layer.getClientRects().length);
      if (show === isOpen) return;
      if (!show) {
        const close = document.querySelector('.dfd-mobile .dfd-close-filters-button, .dfd-mobile [dfd-click="hide-filters"]');
        if (close) close.click();
      } else {
        const toggle = document.querySelector('.dfd-mobile .dfd-toggle-filters-button');
        const more = document.querySelector('.dfd-mobile [dfd-click="next-screen"]');
        if (toggle) toggle.click();
        else if (more) {
          // Vorschau-Ansicht: zuerst "Alle anzeigen", dann Filter
          more.click();
          setTimeout(function () {
            const t = document.querySelector('.dfd-mobile .dfd-toggle-filters-button');
            if (t) t.click();
          }, 900);
        }
      }
      setTimeout(syncDoofinderOpen, 400);
      return;
    }
    const aside = document.querySelector('.dfd-aside');
    if (!aside) return;
    if (show && !aside.querySelector(':scope > .hx-dfd-filter-head')) {
      aside.insertAdjacentHTML('afterbegin', '<div class="hx-dfd-filter-head"><span>Filter</span>'
        + '<button type="button" class="hx-dfd-filter-close" aria-label="Filter schliessen">'
        + '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" aria-hidden="true"><path d="M6 6l12 12M18 6L6 18"/></svg>'
        + '</button></div>');
    }
    root.classList.toggle('hx-dfd-filter-open', show);
    if (show) aside.scrollTop = 0;
  }
  // Handy: immer nur ein Fenster offen (Tan 2026-10-28). Wer Menü, Filter, Sortierung, Suche oder
  // Warenkorb öffnet, schliesst zuerst die anderen. Boost-Klassen: Filter-Fenster mit X
  // (.boost-sd__button-text-x--as-close-modal), offene Sortierliste (.boost-sd__sorting-list--active).
  function initOnePanel() {
    const mobile = function () { return window.matchMedia('(max-width: 768.98px)').matches; };
    const visible = function (el) { return !!(el && el.getClientRects().length && getComputedStyle(el).visibility !== 'hidden'); };
    const closeMenu = function () {
      const toggle = document.querySelector('store-header .main-menu__toggle');
      if (toggle && toggle.getAttribute('aria-expanded') === 'true') toggle.click();
    };
    // Boost-Filter schliessen: zuerst ein X im Filterfenster, sonst "Ergebnisse anzeigen" (schliesst das Fenster
    // ohne etwas zu ändern), sonst Escape. Boost lädt in Claudes Testumgebung nicht, darum mehrere Wege.
    const closeBoostFilter = function () {
      const buttons = [...document.querySelectorAll('button, [role="button"]')].filter(function (b) {
        return visible(b) && b.closest('[class*="filter-tree"], .hx-boost-drawer') && !b.closest('.hx-bottom-bar');
      });
      const close = buttons.find(function (b) { return /text-x|close/i.test(b.className) && !b.closest('[class*="quick-view"]'); })
        || buttons.find(function (b) { return /^\s*(Ergebnisse anzeigen|Show results|Apply)/i.test(b.textContent); });
      if (close) { close.click(); return; }
      document.dispatchEvent(new KeyboardEvent('keydown', { key: 'Escape', bubbles: true }));
    };
    const boostFilterOpen = function () {
      return [...document.querySelectorAll('.boost-sd__filter-tree-vertical-mobile-toolbar, .boost-sd__button-text-x--as-close-modal')]
        .some(function (el) { return visible(el) && !el.closest('[class*="quick-view"]'); })
        // Das Schliessen-Feld ist auf dem Handy ausgeblendet: "Ergebnisse anzeigen" im Filterfenster zählt auch
        || [...document.querySelectorAll('[class*="boost-sd__"] button, button[class*="boost-sd__"]')].some(function (b) {
          return /^\s*Ergebnisse anzeigen/.test(b.textContent) && visible(b);
        });
    };
    // Filter-Knopf unten: offen = rotes X wie beim Menü (aria-expanded)
    const filterBtn = document.querySelector('.hx-bottom-bar [data-hx-bar="filter"]');
    const syncFilterBtn = function () {
      if (!filterBtn) return;
      const boostOpen = boostFilterOpen();
      const open = document.documentElement.classList.contains('hx-dfd-filter-open') || boostOpen;
      // Boost-Filterfenster endet über der Leiste, die Leiste bleibt sichtbar (Tan 2026-10-28)
      if (document.documentElement.classList.contains('hx-boost-filter-open') !== boostOpen) {
        document.documentElement.classList.toggle('hx-boost-filter-open', boostOpen);
      }
      if (boostOpen) {
        // Ohne Kopfzeile/X (z. B. Unterliste offen) vom Knopf "Ergebnisse anzeigen" aus suchen (2026-10-29)
        const toolbar = [...document.querySelectorAll('.boost-sd__filter-tree-vertical-mobile-toolbar, .boost-sd__button-text-x--as-close-modal')].find(visible)
          || [...document.querySelectorAll('[class*="boost-sd__"] button, button[class*="boost-sd__"]')].find(function (b) {
            return /^\s*Ergebnisse anzeigen/.test(b.textContent) && visible(b);
          });
        let drawer = toolbar;
        while (drawer && drawer !== document.body && getComputedStyle(drawer).position !== 'fixed') drawer = drawer.parentElement;
        if (drawer && drawer !== document.body && !drawer.classList.contains('hx-boost-drawer')) drawer.classList.add('hx-boost-drawer');
        // Überschrift "Filter" markieren, damit sie nicht umbricht (CSS in custom-main.css),
        // und links genau bündig mit dem Text der ersten Filterzeile darunter setzen (Tan 2026-10-29)
        if (drawer && drawer !== document.body) {
          const leaves = [...drawer.querySelectorAll('*')].filter(function (el) {
            return !el.children.length && el.textContent.trim() && visible(el);
          });
          const title = leaves.find(function (el) { return /^\s*filter\s*$/i.test(el.textContent); });
          // Boost schreibt in dieselbe Überschrift später z. B. "PRODUKTTYP": Markierung und Abstand dann weg (Tan 2026-10-30)
          drawer.querySelectorAll('.hx-boost-filter-title').forEach(function (el) {
            if (el !== title) { el.classList.remove('hx-boost-filter-title'); el.style.removeProperty('margin-left'); }
          });
          if (title) {
            if (!title.classList.contains('hx-boost-filter-title')) title.classList.add('hx-boost-filter-title');
            const titleBox = title.getBoundingClientRect();
            const row = leaves.find(function (el) { return el !== title && el.getBoundingClientRect().top >= titleBox.bottom - 1; });
            if (row) {
              const range = document.createRange();
              range.selectNodeContents(title);
              const delta = Math.round(row.getBoundingClientRect().left - range.getBoundingClientRect().left);
              if (Math.abs(delta) > 1) {
                const current = parseFloat(title.style.marginLeft) || 0;
                title.style.setProperty('margin-left', (current + delta) + 'px', 'important');
              }
            }
          }
        }
      }
      const value = open ? 'true' : 'false';
      if (filterBtn.getAttribute('aria-expanded') !== value) filterBtn.setAttribute('aria-expanded', value);
    };
    if (filterBtn) {
      let pending = false;
      new MutationObserver(function (records) {
        if (pending || !hxBoostRelevant(records)) return;
        pending = true;
        requestAnimationFrame(function () { pending = false; syncFilterBtn(); });
      }).observe(document.documentElement, { childList: true, subtree: true, attributes: true, attributeFilter: ['class', 'style'] });
      document.addEventListener('click', function () { setTimeout(syncFilterBtn, 400); }, true);
    }
    const closeBoostSort = function () {
      if (!document.querySelector('.boost-sd__sorting-list--active')) return;
      const btn = document.querySelector('.boost-sd__sorting-button');
      if (btn) btn.click();
    };
    document.addEventListener('click', function (event) {
      if (!mobile() || !event.target.closest) return;
      const t = event.target;
      const bar = t.closest('.hx-bottom-bar [data-hx-bar]');
      const type = bar ? bar.dataset.hxBar : '';
      const isMenu = type === 'menu' || t.closest('store-header .main-menu__toggle');
      const isFilter = type === 'filter' || t.closest('.boost-sd__filter-tree-toggle-button, .boost-sd__toolbar-top-mobile [class*="filter-tree-toggle"]');
      const isSort = t.closest('.boost-sd__sorting-button');
      const isOther = type === 'search' || type === 'cart' || type === 'account';
      if (!isMenu && !isFilter && !isSort && !isOther) return;
      // Filter-Knopf unten bei offenem Boost-Filter = X: schliessen statt nochmals öffnen
      if (type === 'filter' && !document.documentElement.classList.contains('hx-dfd-open') && boostFilterOpen()) {
        event.preventDefault();
        event.stopImmediatePropagation();
        closeBoostFilter();
        return;
      }
      if (!isMenu) closeMenu();
      if (!isFilter) closeBoostFilter();
      if (!isSort) closeBoostSort();
    }, true);
  }

  function initDoofinderCards() {
    // Nach "In den Warenkorb" aus der Suche: Suchfenster schliessen, damit der Warenkorb sichtbar ist
    ['on:cart:add', 'on:line-item:change'].forEach(function (name) {
      document.addEventListener(name, function (event) {
        if (!event.target.closest || !event.target.closest('.hx-dfd-card')) return;
        dfdClose();
      });
    });
    // Handy: oberer Teil (Vorschläge) klappt beim Runterscrollen der Ergebnisse weg, ganz oben wieder auf
    document.addEventListener('scroll', function (event) {
      const el = event.target;
      if (!el || !el.closest || !el.closest('.dfd-root') || el.closest('.dfd-aside, .dfd-filters-layer')) return;
      if (!window.matchMedia('(max-width: 768.98px)').matches) return;
      const root = document.documentElement;
      if (el.scrollTop > 40 && !root.classList.contains('hx-dfd-scrolled')) {
        root.classList.add('hx-dfd-scrolled');
        if (document.activeElement && document.activeElement.matches('.dfd-searchbox-input')) document.activeElement.blur();
      } else if (el.scrollTop < 5 && root.classList.contains('hx-dfd-scrolled')) {
        root.classList.remove('hx-dfd-scrolled');
      }
    }, true);
    // Öffnen/Schliessen des Suchfensters erkennen (Doofinder baut das Fenster beim Tippen auf)
    ['click', 'focusin', 'keyup'].forEach(function (name) {
      document.addEventListener(name, function () { setTimeout(syncDoofinderOpen, 350); }, true);
    });
    // Handy-Leiste unten, solange die Suche offen ist (Tan 2026-10-28):
    // Filter = Filter der Suche, Lupe = Suchfeld, Menü/Warenkorb schliessen zuerst die Suche
    document.addEventListener('click', function (event) {
      const root = document.documentElement;
      if (event.target.closest('.hx-dfd-filter-close')) {
        event.preventDefault();
        dfdToggleFilter(false);
        return;
      }
      const btn = event.target.closest('.hx-bottom-bar [data-hx-bar]');
      if (!btn || !root.classList.contains('hx-dfd-open')) return;
      const type = btn.dataset.hxBar;
      if (type === 'filter') {
        event.preventDefault();
        event.stopImmediatePropagation();
        dfdToggleFilter(!root.classList.contains('hx-dfd-filter-open'));
      } else if (type === 'search') {
        event.preventDefault();
        event.stopImmediatePropagation();
        dfdToggleFilter(false);
        root.classList.remove('hx-dfd-scrolled');
        document.querySelectorAll('.dfd-root .dfd-content, .dfd-root .dfd-tabs, .dfd-layer').forEach(function (el) { el.scrollTop = 0; });
        const input = document.querySelector('.dfd-searchbox-input, .dfd-root input[type="search"]');
        if (input) input.focus();
      } else if (type === 'menu' || type === 'cart') {
        dfdToggleFilter(false);
        dfdClose();
        root.classList.remove('hx-dfd-open');
      }
    }, true);
  }

  function initWholePriceFormat() {
    let pending = false;
    // Das CSS dazu steht in assets/custom-main.css (Tan 2026-10-28: alle eigenen CSS dort)
    const refresh = function () {
      layoutDoofinderCards();
      syncDoofinderOpen();
      formatWholePrices();
      layoutBoostCards();
      updateThemeCards();
      updateCrossCards();
      flushAlignBlack();
      tightenCardBottoms();
      alignBoostPrices();
    };
    watchStockTexts();
    refresh();
    // Nur bei geänderter Breite: Die Adressleiste auf dem Handy ändert beim Scrollen nur die Höhe
    let alignWidth = window.innerWidth;
    window.addEventListener('resize', function () {
      if (window.innerWidth === alignWidth) return;
      alignWidth = window.innerWidth;
      alignBoostPrices();
    });
    window.addEventListener('load', alignBoostPrices);
    const OWN = '.hx-price-below, .hx-stock-price, .hx-card-shipping, .hx-card-saving, .hx-card-extra, .hx-quick-buttons';
    // Sicherung gegen Endlosschleifen mit Boost: mehr als 20 Durchläufe in 2 Sekunden = 1 Sekunde Pause
    let runs = [];
    let pausedUntil = 0;
    new MutationObserver(function (mutations) {
      if (pending || !hxRelevant(mutations)) return;
      // Nur eigene Umbauten in den Karten: kein neuer Durchlauf, sonst läuft es im Kreis und flackert
      if (mutations.every(function (m) { return m.target.closest && m.target.closest(OWN); })) return;
      const now = Date.now();
      if (now < pausedUntil) return;
      runs = runs.filter(function (t) { return now - t < 2000; });
      if (runs.length >= 20) {
        // Nach der Pause einmal nachholen, damit nachgeladene Karten trotzdem fertig werden
        pausedUntil = now + 1000;
        runs = [];
        setTimeout(refresh, 1050);
        return;
      }
      runs.push(now);
      pending = true;
      requestAnimationFrame(function () {
        pending = false;
        refresh();
      });
    }).observe(document.body, { childList: true, subtree: true });
  }

  // Handy, Produktseite: Produkt-Slider (Ähnliche Produkte, Empfehlungen) wischen einmal kurz nach links
  // und zurück, sobald sie ins Bild kommen. Zeigt, dass man seitlich wischen kann (Tan 2026-10-26).
  // Nicht in der Bildergalerie und nicht bei "Bewegung reduzieren".
  // Startseite: Info-Slider ("Aus der Schweiz …") und "Unsere Blogs" wischen ebenfalls kurz an (Tan 2026-10-29)
  // Info-Kacheln (Icons mit Text) am Handy: Antippen einer Kachel zeigt die nächste, am Ende wieder die erste (Tan 2026-10-30)
  function initIconsTextTap() {
    document.addEventListener('click', function (event) {
      if (!window.matchMedia('(max-width: 768.98px)').matches) return;
      const item = event.target.closest('.cc-icons-with-text .slider__item');
      if (!item || event.target.closest('a, button')) return;
      const track = item.closest('.slider');
      if (!track || track.scrollWidth <= track.clientWidth + 10) return;
      const atEnd = track.scrollLeft + track.clientWidth >= track.scrollWidth - 10;
      track.scrollTo({ left: atEnd ? 0 : track.scrollLeft + item.offsetWidth, behavior: 'smooth' });
    });
    // Pfeil am Handy immer rechts, für den Daumen (Tan 2026-10-30): linker Pfeil per CSS aus, rechter nie gesperrt,
    // auf der letzten Kachel springt er zur ersten
    const phone = window.matchMedia('(max-width: 768.98px)');
    document.querySelectorAll('.cc-icons-with-text .slider-nav__btn[name="next"]').forEach(function (btn) {
      const free = function () { if (phone.matches && btn.disabled) btn.disabled = false; };
      new MutationObserver(free).observe(btn, { attributes: true, attributeFilter: ['disabled'] });
      phone.addEventListener('change', free);
      free();
      // Auf der letzten Kachel zeigt der Pfeil nach links: er führt zurück zum Anfang (Tan 2026-10-30)
      const slider = btn.closest('.cc-icons-with-text').querySelector('.slider');
      const turn = function () {
        const back = phone.matches && !!slider && slider.scrollWidth > slider.clientWidth + 10
          && slider.scrollLeft + slider.clientWidth >= slider.scrollWidth - 10;
        btn.classList.toggle('hx-zurueck', back);
        if (back) btn.setAttribute('aria-label', 'Zurück zum Anfang');
        else btn.removeAttribute('aria-label');
      };
      if (slider) slider.addEventListener('scroll', turn, { passive: true });
      window.addEventListener('resize', turn);
      phone.addEventListener('change', turn);
      turn();
      btn.addEventListener('click', function (event) {
        if (!phone.matches) return;
        const track = btn.closest('.cc-icons-with-text').querySelector('.slider');
        if (!track || track.scrollLeft + track.clientWidth < track.scrollWidth - 10) return;
        event.preventDefault();
        event.stopImmediatePropagation();
        track.scrollTo({ left: 0, behavior: 'smooth' });
      }, true);
    });
  }

  function initSwipeHint() {
    const home = location.pathname === '/';
    if (!home && !/^\/products\//.test(location.pathname)) return;
    if (!window.IntersectionObserver || !Element.prototype.animate) return;
    if (!window.matchMedia('(max-width: 768px)').matches) return;
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    const seen = new WeakSet();
    // Bei jedem Hineinscrollen wiederholen, egal ob von oben oder unten (Tan 2026-10-26).
    // Erst wenn der Slider ganz aus dem Bild war, darf er wieder wischen.
    const armed = new WeakSet();
    const observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        const track = entry.target;
        if (!entry.isIntersecting) { armed.add(track); return; }
        if (entry.intersectionRatio < 0.6 || !armed.has(track)) return;
        armed.delete(track);
        if (track.scrollWidth <= track.clientWidth + 10 || track.scrollLeft > 2) return;
        // Startseite: die Liste im Slider bewegen, damit rechts die nächste Kachel hereinschaut
        (home ? track.querySelector('.slider__grid') || track : track).animate(
          [{ transform: 'translateX(0)' }, { transform: 'translateX(-56px)' }, { transform: 'translateX(0)' }],
          { duration: 1100, delay: 250, easing: 'ease-in-out' }
        );
      });
    }, { threshold: [0, 0.6] });
    const watch = function () {
      const selector = home ? '.cc-icons-with-text .slider, .cc-featured-blog .slider' : '.slider, [data-related-products-track]';
      document.querySelectorAll(selector).forEach(function (track) {
        if (seen.has(track) || track.closest('media-gallery, .media-gallery, .media-viewer, .product-media')) return;
        seen.add(track);
        armed.add(track);
        observer.observe(track);
      });
    };
    watch();
    // Empfehlungen werden teils nachgeladen
    setTimeout(watch, 1500);
    setTimeout(watch, 4000);
  }

  // Info-Kacheln "Spare jetzt bis zu 80% / 100% Qualität / Umweltfreundlich" auf den Tinten-&-Toner-
  // Produktseiten (Tan 2026-10-29): am Handy Text gekürzt mit Verlauf, Antippen klappt ihn auf.
  // Die Section hat in allen drei Templates (product.tinten-toner*) dieselbe ID. Text bleibt im HTML (SEO).
  // Sticky-Leiste "Optionen auswählen": zur Variantenauswahl scrollen und sie zweimal orange aufblinken lassen (Tan 2026-10-29)
  function initStickyOptionsHighlight() {
    document.addEventListener('click', function (event) {
      const link = event.target.closest('sticky-atc-panel .card__buttons a[href^="#"]');
      if (!link) return;
      const section = link.closest('.cc-main-product') || document;
      const picker = section.querySelector('.product-info variant-picker') || section.querySelector('variant-picker');
      if (!picker) return;
      event.preventDefault();
      const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      let done = false;
      const flash = function () {
        if (done) return;
        done = true;
        picker.classList.remove('hx-options-flash');
        void picker.offsetWidth;
        picker.classList.add('hx-options-flash');
        window.setTimeout(function () { picker.classList.remove('hx-options-flash'); }, 1800);
      };
      if ('onscrollend' in window) window.addEventListener('scrollend', flash, { once: true });
      window.setTimeout(flash, reduce ? 50 : 900);
      picker.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'center' });
      // Tastatur: Fokus in die Auswahl setzen
      const first = event.detail === 0 && picker.querySelector('input:checked, input, select');
      if (first) first.focus({ preventScroll: true });
    });
  }

  // Klaviyo-Teaser "Neu hier? Sichere dir jetzt 10%" (Formular "Newsletter Anmeldung Popup"): Klaviyo zeichnet ihn erst nach
  // dem Laden und vergibt keine festen Klassen, darum hier markieren. CSS in custom-main.css setzt ihn auf dem Handy direkt
  // über die Leiste unten und das X rechts in Rot (Tan 2026-10-30). Die Klaviyo-Einstellung gilt auch für den Live-Shop,
  // darum nicht dort geändert. --hx-kl-teaser-h schiebt Sticky-Warenkorb und Nach-oben-Pfeil darüber.
  function initKlaviyoTeaser() {
    const root = document.documentElement;
    let queued = false;

    function fixedRoot(el) {
      let found = null;
      for (let node = el; node && node !== document.body; node = node.parentElement) {
        if (getComputedStyle(node).position === 'fixed') found = node;
      }
      return found;
    }

    function update() {
      queued = false;
      let teaser = document.querySelector('.hx-kl-teaser');
      if (!teaser || !teaser.isConnected) {
        const hit = document.querySelector('[class*="kl-teaser"]');
        teaser = hit && fixedRoot(hit);
        if (teaser) teaser.classList.add('hx-kl-teaser');
      }
      if (teaser) {
        const close = Array.prototype.find.call(teaser.querySelectorAll('button'), function (button) {
          return /close|schlie/i.test(button.getAttribute('aria-label') || '') || (button.querySelector('svg') && !button.textContent.trim());
        });
        if (close && !close.classList.contains('hx-kl-teaser__close')) {
          close.classList.add('hx-kl-teaser__close');
          // Klaviyo setzt die Lage meist an einem umschliessenden Element, darum das nächste absolut gesetzte mitmarkieren
          for (let node = close; node && node !== teaser; node = node.parentElement) {
            if (getComputedStyle(node).position === 'absolute') { node.classList.add('hx-kl-teaser__close-pos'); break; }
          }
        }
      }
      const box = teaser && (teaser.querySelector('[class*="kl-teaser"]') || teaser);
      const height = teaser ? Math.max(teaser.offsetHeight, box.offsetHeight) : 0;
      root.classList.toggle('hx-kl-teaser-on', height > 0);
      if (height > 0) root.style.setProperty('--hx-kl-teaser-h', height + 'px');
      else root.style.removeProperty('--hx-kl-teaser-h');
    }

    new MutationObserver(function (records) {
      if (queued || !hxRelevant(records)) return;
      queued = true;
      requestAnimationFrame(update);
    }).observe(document.body, { childList: true, subtree: true });
    window.addEventListener('resize', update);
    update();
  }

  function initInfoTileToggles() {
    // Zweite Section: "Sucharten erklärt" (Druckerserie & Modell finden …) unter dem Patronen-Finder auf der Kategorie
    // Tinten & Toner (Template collection.level-1-tinten-toner), dort nur die ersten zwei Zeilen sichtbar (Tan 2026-10-30)
    document.querySelectorAll('[id$="__994baa13-c848-42a1-a94c-60f997fb3cd0"], [id$="__df452e95-283d-4659-95e4-c9c4d859dca9"]').forEach(function (section) {
      section.classList.add('hx-info-tiles');
      if (/__df452e95-/.test(section.id)) section.classList.add('hx-info-tiles--kurz');
      section.querySelectorAll('.card__rte').forEach(function (text, index) {
        if (text.dataset.hxToggle) return;
        text.dataset.hxToggle = 'true';
        if (!text.id) text.id = section.id + '-text-' + index;
        const button = document.createElement('button');
        button.type = 'button';
        button.className = 'hx-info-toggle';
        button.setAttribute('aria-expanded', 'false');
        button.setAttribute('aria-controls', text.id);
        button.innerHTML = '<span>Mehr anzeigen</span><svg width="12" height="12" viewBox="0 0 12 12" aria-hidden="true" focusable="false"><path d="M2 4l4 4 4-4" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>';
        text.insertAdjacentElement('afterend', button);
        const toggle = function () {
          const open = text.classList.toggle('is-open');
          button.setAttribute('aria-expanded', open ? 'true' : 'false');
          button.firstChild.textContent = open ? 'Weniger anzeigen' : 'Mehr anzeigen';
        };
        button.addEventListener('click', toggle);
        // Antippen des gekürzten Textes klappt ebenfalls auf (nur solange zu, damit Text markierbar bleibt)
        text.addEventListener('click', function (event) {
          if (text.classList.contains('is-open') || event.target.closest('a')) return;
          if (window.matchMedia('(max-width: 768px)').matches) toggle();
        });
      });
    });
  }

  // Handy, Kollektionen "… Patronen Nr." und "… Druckermodelle" (Menü Tinten + Toner): Filterfenster beim Öffnen
  // der Seite sofort offen, direkt in der Liste "Patronen Nr. wählen" bzw. "Druckermodell wählen" (Tan 2026-10-29). Boost hängt seine Klicks erst eine Weile nach dem
  // Zeichnen an, darum bei jeder Änderung und alle 250 ms neu versuchen (max. 30 s), bis die Liste angeklickt ist. Tippt der Kunde
  // selbst, hören wir auf. Boost lädt in Claudes Testumgebung nicht, darum über Texte statt Klassen.
  function initPatronenNrFilter() {
    const page = location.pathname.match(/^\/collections\/[^/]+-(patronen-nr|druckermodelle)\/?$/);
    if (!page) return;
    const groupText = page[1] === 'patronen-nr' ? /patronen\s*nr/i : /druckermodell/i;
    if (!window.matchMedia('(max-width: 768.98px)').matches) return;
    const visible = function (el) { return !!(el && el.getClientRects().length && getComputedStyle(el).visibility !== 'hidden'); };
    const started = Date.now();
    let lastOpen = 0;
    let lastPick = 0;
    let timer = null;
    let observer = null;
    const stop = function () { clearInterval(timer); if (observer) observer.disconnect(); document.removeEventListener('pointerdown', onUser, true); };
    const onUser = function (evt) { if (evt.isTrusted) stop(); };
    const filterOpen = function () {
      return [...document.querySelectorAll('.boost-sd__filter-tree-vertical-mobile-toolbar, .boost-sd__button-text-x--as-close-modal, [class*="boost-sd__"] button, button[class*="boost-sd__"]')]
        .some(function (el) { return visible(el) && (!/^BUTTON$/.test(el.tagName) || /^\s*Ergebnisse anzeigen/.test(el.textContent) || /close-modal/.test(el.className)); });
    };
    const tick = function () {
      if (Date.now() - started > 30000) { stop(); return; }
      // 1. Liste "Patronen Nr." im offenen Filterfenster anklicken
      if (filterOpen()) {
        // Unterliste schon offen (Suchfeld "Suchoptionen" oder Filterwerte sichtbar): fertig
        const subOpen = [...document.querySelectorAll('.hx-boost-drawer input, [class*="boost-sd__filter"] input')].some(function (i) { return visible(i) && /suchoption/i.test(i.placeholder || ''); })
          || [...document.querySelectorAll('[class*="boost-sd__filter-option-item"]')].some(visible);
        if (subOpen) { stop(); return; }
        const label = [...document.querySelectorAll('[class*="boost-sd__filter-tree"] *, [class*="boost-sd__filter-option"] *, .hx-boost-drawer *')].find(function (el) {
          return !el.children.length && groupText.test(el.textContent) && visible(el) && !el.closest('a, .hx-bottom-bar');
        });
        if (!label) return;
        // Boost nimmt Klicks während des Einblendens nicht an: alle 0,5 s erneut, bis die Liste offen ist
        if (Date.now() - lastPick < 500) return;
        lastPick = Date.now();
        const target = label.closest('button, [role="button"], [class*="title"]') || label;
        ['pointerdown', 'mousedown', 'pointerup', 'mouseup'].forEach(function (type) {
          target.dispatchEvent(new (window.PointerEvent && /^pointer/.test(type) ? PointerEvent : MouseEvent)(type, { bubbles: true, cancelable: true, view: window }));
        });
        target.click();
        return;
      }
      // 2. Filterfenster öffnen (höchstens alle 0,5 s, falls Boost den Klick noch nicht annimmt)
      if (Date.now() - lastOpen < 500) return;
      const toggle = document.querySelector('.boost-sd__filter-tree-toggle-button-icon');
      const btn = toggle ? (toggle.closest('button, [role="button"], .boost-sd__filter-tree-toggle-button') || toggle) : null;
      if (!btn) return;
      lastOpen = Date.now();
      btn.click();
    };
    document.addEventListener('pointerdown', onUser, true);
    // Sofort reagieren, sobald Boost etwas zeichnet; das Intervall fängt Klicks auf, die Boost noch ignoriert
    let pending = false;
    observer = new MutationObserver(function (records) {
      if (pending || !hxRelevant(records)) return;
      pending = true;
      requestAnimationFrame(function () { pending = false; tick(); });
    });
    observer.observe(document.body, { childList: true, subtree: true });
    timer = setInterval(tick, 250);
    tick();
  }

  // Handy, Boost-Filter: Sobald ein Filterwert angetippt ist, Fenster zu und Ergebnisse zeigen (Tan 2026-10-29).
  // Boost übernimmt die Auswahl erst mit "Ergebnisse anzeigen", darum kurz warten und diesen Knopf drücken.
  function initBoostFilterAutoClose() {
    if (!/^\/collections\/|^\/search/.test(location.pathname)) return;
    const visible = function (el) { return !!(el && el.getClientRects().length && getComputedStyle(el).visibility !== 'hidden'); };
    document.addEventListener('click', function (evt) {
      if (!window.matchMedia('(max-width: 768.98px)').matches) return;
      const option = evt.target.closest(':is(li, button, a, label)[class*="boost-sd__filter-option-item"]');
      if (!option || option.closest('[class*="viewmore"]')) return;
      let tries = 0;
      const apply = function () {
        const btn = [...document.querySelectorAll('[class*="boost-sd__"] button, button[class*="boost-sd__"]')].find(function (b) {
          return visible(b) && /^\s*(Ergebnisse anzeigen|Show results|Apply)/i.test(b.textContent);
        });
        if (btn && !btn.disabled) { btn.click(); return; }
        if (++tries < 20) setTimeout(apply, 100);
      };
      setTimeout(apply, 400);
    }, true);
  }

  // Handy, Boost-Filterfenster (Tan 2026-10-29): oben die Zeile mit "PATRONEN NR. WÄHLEN" + "Entfernen" auf eine
  // Zeile bringen ("Entfernen" rechts) und unten über "Ergebnisse anzeigen" einen roten Knopf "Filter leeren" zeigen,
  // der Boosts "Entfernen" drückt. Boost lädt in Claudes Testumgebung nicht, darum über Texte statt Klassen.
  function initBoostFilterClear() {
    if (!/^\/collections\/|^\/search/.test(location.pathname)) return;
    const visible = function (el) { return !!(el && el.getClientRects().length && getComputedStyle(el).visibility !== 'hidden'); };
    let ours = null;
    let boostClear = null;
    const sync = function () {
      const drawer = document.querySelector('.hx-boost-drawer');
      const mobile = window.matchMedia('(max-width: 768.98px)').matches;
      const buttons = drawer && mobile ? [...drawer.querySelectorAll('button, [role="button"], a')] : [];
      // Nur Boosts "Entfernen" in der Kopfzeile des Fensters. Boost hat in jeder Filtergruppe ein weiteres "Entfernen";
      // traf es dieses, wurde die ganze Filtergruppe zur Zeile ("Kategorie" links neben der Liste, Tan 2026-10-30)
      boostClear = buttons.find(function (b) {
        return b !== ours && b.closest('.boost-sd__filter-tree-vertical-mobile-toolbar') && !b.classList.contains('boost-sd__g-hide')
          && /^\s*(Entfernen|Alle entfernen|Alles entfernen|Clear all|Clear)\s*$/i.test(b.textContent);
      }) || null;
      // Nur zeigen, wenn wirklich etwas gewählt ist: Chips in der Leiste oben oder ein angehakter Filterwert
      let hasSelection = false;
      if (boostClear) {
        const refine = boostClear.closest('[class*="refine-by"]');
        const clearText = boostClear.textContent.trim();
        if (refine && refine.textContent.replace(clearText, '').trim()) hasSelection = true;
        if (drawer.querySelector('[class*="filter-option-item"] input:checked, [class*="filter-option-item"][aria-checked="true"], [class*="filter-option-item"] [aria-checked="true"], [class*="filter-option-item"][class*="--selected"], [class*="filter-option-item"][class*="--active"]')) hasSelection = true;
      }
      // Zeile mit "Entfernen" bleibt (Tan 2026-10-29, ersetzt das Ausblenden): Titel links auf einer Zeile,
      // "Entfernen" ganz rechts. Klassen für assets/custom-main.css.
      // Boost verwendet seine Elemente nach dem Leeren für anderes weiter: alte Markierungen immer erst entfernen,
      // sonst wird z. B. die Zeile "Patronen Nr. wählen" zur Flex-Zeile und das Fenster verschoben (Tan 2026-10-29)
      // Die Kopfzeile ordnet jetzt assets/custom-main.css direkt (Boost-Klasse), keine Zeile mehr markieren (2026-10-30)
      const row = null;
      document.querySelectorAll('.hx-clear-row, .hx-clear-btn').forEach(function (el) {
        if (el !== row && el !== boostClear) el.classList.remove('hx-clear-row', 'hx-clear-btn');
      });
      if (row && !row.classList.contains('hx-clear-row')) row.classList.add('hx-clear-row');
      if (boostClear && !boostClear.classList.contains('hx-clear-btn')) boostClear.classList.add('hx-clear-btn');
      const apply = buttons.find(function (b) { return !b.classList.contains('hx-apply-top') && (visible(b) || b.closest('.hx-apply-hidden')) && /^\s*Ergebnisse anzeigen/.test(b.textContent); });
      if (!boostClear || !apply || !hasSelection) { if (ours && ours.isConnected) ours.remove(); return; }
      if (!ours) {
        ours = document.createElement('button');
        ours.type = 'button';
        ours.className = 'hx-filter-clear';
        ours.textContent = 'Filter leeren';
        ours.addEventListener('click', function () { if (boostClear) boostClear.click(); });
      }
      // Über den Knopf "Ergebnisse anzeigen" (bzw. seine Hülle, wenn sie nur ihn enthält)
      const anchor = apply.parentElement && apply.parentElement.children.length === 1 && apply.parentElement !== drawer ? apply.parentElement : apply;
      if (ours.nextElementSibling !== anchor) anchor.parentElement.insertBefore(ours, anchor);
    };
    let pending = false;
    new MutationObserver(function (records) {
      if (pending || !hxRelevant(records) || records.every(function (r) { return r.target === ours || (ours && ours.contains(r.target)); })) return;
      pending = true;
      requestAnimationFrame(function () { pending = false; sync(); });
    }).observe(document.body, { childList: true, subtree: true, attributes: true, attributeFilter: ['class'] });
  }

  // Handy, Boost-Filterfenster: Ist eine Filtergruppe offen (Kopfzeile zeigt z. B. "KATEGORIE"), nur deren Liste über die
  // ganze Breite zeigen: ohne den Titel "Kategorie" daneben und ohne die anderen Gruppen darunter (Tan 2026-10-30).
  // Boost zeigt nach "Entfernen" sonst Titel und Liste nebeneinander. Markiert wird nur, wenn die Liste der Gruppe
  // wirklich sichtbar ist; sonst bleibt alles wie von Boost gezeichnet. Klasse für assets/custom-main.css.
  function initBoostOpenOption() {
    if (!/^\/collections\/|^\/search/.test(location.pathname)) return;
    const norm = function (t) { return (t || '').replace(/\s+/g, ' ').trim().toLowerCase(); };
    const sync = function () {
      const drawer = document.querySelector('.hx-boost-drawer');
      const middle = drawer && window.matchMedia('(max-width: 768.98px)').matches ? drawer.querySelector('.boost-sd__filter-tree-vertical-toolbar-middle') : null;
      // Boost hat für die Hauptliste keine deutsche Überschrift und schreibt nach dem Zurück-Pfeil "Refine by" (Tan 2026-10-30)
      if (middle && /^\s*refine by\s*$/i.test(middle.textContent)) middle.textContent = 'Filter';
      // Nach dem Filtern zeigt Boost die Übersicht, lässt oben aber den Namen der zuletzt offenen Gruppe stehen
      // (z. B. "Farbe"). Übersicht = kein Zurück-Pfeil sichtbar und keine Werteliste offen: dann "Filter" (Tan 2026-10-30)
      const backBtn = middle ? drawer.querySelector('.boost-sd__filter-tree-vertical-mobile-toolbar .boost-sd__button--back:not(.boost-sd__button--hidden)') : null;
      const anyOpen = middle ? [...drawer.querySelectorAll('.boost-sd__filter-option-itemwrapper')].some(function (w) { return w.getClientRects().length > 0; }) : false;
      if (middle && !(backBtn && backBtn.getClientRects().length) && !anyOpen && norm(middle.textContent) !== 'filter') middle.textContent = 'Filter';
      const head = middle ? norm(middle.textContent) : '';
      let current = null;
      if (head) {
        current = [...drawer.querySelectorAll('.boost-sd__filter-option')].find(function (opt) {
          const heading = opt.querySelector('.boost-sd__filter-option-heading');
          const wrapper = opt.querySelector('.boost-sd__filter-option-itemwrapper');
          // Liste darf nicht im Titel stecken, sonst würde das Ausblenden des Titels auch die Liste verstecken
          return heading && wrapper && !wrapper.closest('.boost-sd__filter-option-title') && norm(heading.textContent) === head
            && wrapper.getClientRects().length > 0;
        }) || null;
      }
      document.querySelectorAll('.hx-opt-current').forEach(function (el) { if (el !== current) el.classList.remove('hx-opt-current'); });
      if (current && !current.classList.contains('hx-opt-current')) current.classList.add('hx-opt-current');
      // Gruppe wieder offen: den in der Übersicht versteckten Zurück-Pfeil (siehe initBoostCollapseArrow) wieder zeigen
      if (current) document.querySelectorAll('.hx-back-off').forEach(function (el) { el.classList.remove('hx-back-off'); });
    };
    let pending = false;
    new MutationObserver(function (records) {
      if (pending || !hxRelevant(records)) return;
      pending = true;
      requestAnimationFrame(function () { pending = false; sync(); });
    }).observe(document.body, { childList: true, subtree: true, characterData: true, attributes: true, attributeFilter: ['class'] });
  }

  // Handy, Boost-Filterfenster: Ist eine Filtergruppe offen, rechts im Knopf "Ergebnisse anzeigen" ein roter Pfeil nach oben,
  // der die Gruppe zuklappt wie Boosts Zurück-Pfeil oben (Tan 2026-10-30, Daumen). Der Pfeil hängt am body (position: fixed)
  // und wird über den Knopf gelegt; an Boosts Hüllen wird nichts umgestellt. Klasse für assets/custom-main.css.
  function initBoostCollapseArrow() {
    if (!/^\/collections\/|^\/search/.test(location.pathname)) return;
    const visible = function (el) { return !!(el && el.getClientRects().length && getComputedStyle(el).visibility !== 'hidden'); };
    let arrow = null;
    let raf = 0;
    const find = function () {
      const drawer = document.querySelector('.hx-boost-drawer');
      if (!drawer || !window.matchMedia('(max-width: 768.98px)').matches) return null;
      // Boosts Zurück-Pfeil oben schliesst das ganze Fenster; zur Übersicht führt nur ein zweiter Tipp auf den
      // Titel der offenen Gruppe (auf der echten Seite geprüft, Tan 2026-10-30). Der Titel ist per CSS versteckt, klickbar bleibt er.
      const title = drawer.querySelector('.hx-opt-current .boost-sd__filter-option-title');
      if (!title) return null;
      const apply = [...drawer.querySelectorAll('button, [role="button"]')].find(function (b) {
        return visible(b) && /^\s*Ergebnisse anzeigen/.test(b.textContent);
      });
      return apply ? { title: title, apply: apply } : null;
    };
    const place = function () {
      raf = 0;
      const f = find();
      if (!f) { if (arrow && arrow.isConnected) arrow.remove(); return; }
      if (!arrow) {
        arrow = document.createElement('button');
        arrow.type = 'button';
        arrow.className = 'hx-filter-collapse';
        arrow.setAttribute('aria-label', 'Filter zuklappen');
        arrow.innerHTML = '<svg viewBox="0 0 24 24" width="24" height="24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M6 15l6-6 6 6"/></svg>';
        arrow.addEventListener('click', function () { const g = find(); if (g) toOverview(g); });
      }
      if (!arrow.isConnected) document.body.appendChild(arrow);
      const r = f.apply.getBoundingClientRect();
      const size = Math.round(Math.min(48, r.height));
      arrow.style.setProperty('--hx-arrow-top', Math.round(r.top + (r.height - size) / 2) + 'px');
      arrow.style.setProperty('--hx-arrow-left', Math.round(r.right - size - 4) + 'px');
      arrow.style.setProperty('--hx-arrow-size', size + 'px');
      // Fenster gleitet beim Öffnen herein: solange der Pfeil steht, jedes Bild nachziehen
      raf = requestAnimationFrame(place);
    };
    // Zurück zur Übersicht. Boost lässt danach oben den Gruppennamen und den Zurück-Pfeil stehen (der dann das ganze
    // Fenster schliesst): Kopfzeile wie bei frisch geöffnetem Fenster, "Filter" ohne Pfeil (Tan 2026-10-30, echte Seite)
    const toOverview = function (g) {
      g.title.click();
      requestAnimationFrame(function () { requestAnimationFrame(function () {
        const drawer = document.querySelector('.hx-boost-drawer');
        if (!drawer || [...drawer.querySelectorAll('.boost-sd__filter-option-itemwrapper')].some(function (w) { return w.getClientRects().length > 0; })) return;
        const middle = drawer.querySelector('.boost-sd__filter-tree-vertical-toolbar-middle');
        if (middle && middle.textContent.trim() !== 'Filter') middle.textContent = 'Filter';
        const back = drawer.querySelector('.boost-sd__filter-tree-vertical-mobile-toolbar .boost-sd__button--back');
        if (back) back.classList.add('hx-back-off');
      }); });
    };
    // Gleiches für Boosts Zurück-Pfeil oben: Ist eine Gruppe offen, zurück zur Übersicht statt Fenster schliessen
    document.addEventListener('click', function (e) {
      const back = e.target.closest && e.target.closest('.hx-boost-drawer .boost-sd__filter-tree-vertical-mobile-toolbar .boost-sd__button--back');
      const g = back && find();
      if (!g) return;
      e.preventDefault();
      e.stopImmediatePropagation();
      toOverview(g);
    }, true);
    new MutationObserver(function (records) { if (!raf && hxRelevant(records)) raf = requestAnimationFrame(place); })
      .observe(document.body, { childList: true, subtree: true, attributes: true, attributeFilter: ['class'] });
  }

  // Boost-Filter (Handy und Desktop): Filterwerte mit (0) Treffern ausblenden, bei allen Filtern (Tan 2026-10-30).
  // Sauberer wäre Boosts eigene Einstellung (zeigt Werte ohne Produkte), die liegt aber im Boost-Admin und gilt auch
  // für den Live-Shop. Boost zeichnet Zahlen beim Filtern neu: bei jeder Änderung neu prüfen. Angehakte Werte bleiben.
  function initBoostHideZero() {
    if (!/^\/collections\/|^\/search/.test(location.pathname)) return;
    // Echte Zahlen je Filtergruppe aus Boosts Antwort (bc-sf-ssr-node/filter): Boost zeichnet nur die ersten 30 Werte,
    // die Seite allein weiss also nicht, ob weiter unten noch Treffer kommen (Tan 2026-10-30: "Anschlüsse" blieb stehen).
    // emptyIds: Gruppen, in denen kein Wert Treffer hat. null = noch keine Antwort gelesen, dann nur nach der Seite urteilen.
    let emptyIds = null;
    let emptyLabels = new Set();
    const isFilterUrl = function (url) { return /\/bc-sf-ssr-node\/(filter|search)\b/.test(String(url || '')); };
    const readData = function (data) {
      const options = data && data.filter && Array.isArray(data.filter.options) ? data.filter.options : null;
      if (!options) return;
      const ids = new Set();
      const labels = new Set();
      // Werte können verschachtelt sein (z. B. "Anschlüsse" ist ein Mehrstufen-Tag-Filter, pf_mlt_…): Treffer zählen wie Boost
      // selbst, also auch in tags/subTags. Gruppen ganz ohne Zahlen (z. B. Preis-Schieber) nie ausblenden.
      const kids = function (v) { return [].concat(Array.isArray(v.tags) ? v.tags : [], Array.isArray(v.subTags) ? v.subTags : []); };
      const hasCount = function (v) { return !!v && (typeof v.doc_count === 'number' || kids(v).some(hasCount)); };
      const hasHits = function (v) { return !!v && ((Number(v.doc_count) || 0) > 0 || kids(v).some(hasHits)); };
      options.forEach(function (o) {
        const values = Array.isArray(o.values) ? o.values : [];
        if (!o.filterOptionId || o.displayType === 'range' || !values.length || !values.some(hasCount)) return;
        if (!values.some(hasHits)) { ids.add(String(o.filterOptionId)); if (o.label) labels.add(String(o.label).replace(/\s+/g, ' ').trim().toLowerCase()); }
      });
      emptyIds = ids;
      emptyLabels = labels;
      window.hxBoostEmptyOptions = [...ids];
      schedule();
    };
    if (window.fetch && !window.fetch.hxZero) {
      const origFetch = window.fetch;
      const wrapped = function (input) {
        const p = origFetch.apply(this, arguments);
        const url = typeof input === 'string' ? input : input && input.url;
        if (isFilterUrl(url)) p.then(function (res) { res.clone().json().then(readData).catch(function () {}); }).catch(function () {});
        return p;
      };
      wrapped.hxZero = true;
      window.fetch = wrapped;
    }
    // Hat Boost schon vor diesem Skript geladen: die letzte Antwort einmal nachlesen
    try {
      const done = performance.getEntriesByType('resource').filter(function (e) { return isFilterUrl(e.name); });
      if (done.length) fetch(done[done.length - 1].name).catch(function () {});
    } catch (e) {}
    const sync = function () {
      const zero = new Set();
      document.querySelectorAll('.boost-sd__filter-option-item-amount').forEach(function (amount) {
        if (!/^\s*\(?\s*0\s*\)?\s*$/.test(amount.textContent)) return;
        const item = amount.closest('li.boost-sd__filter-option-item, .boost-sd__filter-option-item');
        if (!item || item.querySelector('[aria-checked="true"], [class*="--selected"]') || /--selected/.test(item.className)) return;
        zero.add(item);
      });
      document.querySelectorAll('.hx-zero').forEach(function (el) { if (!zero.has(el)) el.classList.remove('hx-zero'); });
      zero.forEach(function (el) { if (!el.classList.contains('hx-zero')) el.classList.add('hx-zero'); });
      // Ganze Filtergruppe ausblenden, wenn kein einziger Wert Treffer hat (z. B. "Anschlüsse", Tan 2026-10-30).
      // Zuerst nach Boosts Zahlen (emptyIds); ohne sie nur, wenn weniger als 30 Werte gezeichnet und alle (0) sind.
      // Die gerade offene Gruppe und Gruppen mit angehaktem Wert bleiben stehen.
      // Gruppen aus Boosts Zahlen finden: über data-filteroptionid oder Boosts Knopf-ID "<id>-toggle" (:: wird zu __)
      const apiEmpty = new Set();
      if (emptyIds) emptyIds.forEach(function (id) {
        document.querySelectorAll('.boost-sd__filter-option').forEach(function (opt) {
          if (opt.getAttribute('data-filteroptionid') === id) apiEmpty.add(opt);
        });
        document.querySelectorAll('[id="' + id.replace(/::/g, '__').replace(/"/g, '') + '-toggle"]').forEach(function (el) {
          const opt = el.closest('.boost-sd__filter-option');
          if (opt) apiEmpty.add(opt);
        });
      });
      // Sicherheitsnetz (Tan 2026-10-30): am echten Boost passte die ID nicht, darum zusätzlich über den Gruppentitel
      if (emptyLabels.size) document.querySelectorAll('.boost-sd__filter-option').forEach(function (opt) {
        const heading = opt.querySelector('.boost-sd__filter-option-heading, [class*="filter-option-title"]');
        const firstText = heading ? (heading.querySelector('.boost-sd__filter-option-heading') || heading) : null;
        let label = '';
        if (firstText) {
          const node = [...firstText.childNodes].find(function (n) { return n.textContent.trim(); });
          label = (node ? node.textContent : firstText.textContent).replace(/\s+/g, ' ').trim().toLowerCase();
        }
        if (label && emptyLabels.has(label)) apiEmpty.add(opt);
      });
      // Letztes Netz: Text des Gruppentitels irgendwo im Filterbaum suchen und die umgebende Filtergruppe nehmen
      if (emptyLabels.size) document.querySelectorAll('[class*="boost-sd__filter-tree"] *, [class*="boost-sd__filter-option"] *').forEach(function (el) {
        if (el.children.length || !emptyLabels.has(el.textContent.replace(/\s+/g, ' ').trim().toLowerCase())) return;
        if (el.closest('.boost-sd__filter-option-itemwrapper, .boost-sd__filter-tree-vertical-mobile-toolbar')) return;
        const opt = el.closest('.boost-sd__filter-option') || el.closest('[class*="boost-sd__filter-option"]:not([class*="-item"]):not([class*="heading"]):not([class*="title"]):not([class*="label"])');
        if (opt) apiEmpty.add(opt);
      });
      const empty = new Set();
      document.querySelectorAll('.boost-sd__filter-option').forEach(function (opt) {
        if (opt.classList.contains('hx-opt-current') || opt.querySelector('[aria-checked="true"], [class*="item-button--selected"]')) return;
        if (apiEmpty.has(opt)) { empty.add(opt); return; }
        const items = opt.querySelectorAll('.boost-sd__filter-option-item');
        if (!items.length || items.length >= 30) return;
        if ([...items].every(function (el) { return zero.has(el); })) empty.add(opt);
      });
      apiEmpty.forEach(function (opt) {
        if (!opt.classList.contains('hx-opt-current') && !opt.querySelector('[aria-checked="true"], [class*="item-button--selected"]')) empty.add(opt);
      });
      document.querySelectorAll('.hx-opt-empty').forEach(function (el) { if (!empty.has(el)) el.classList.remove('hx-opt-empty'); });
      empty.forEach(function (el) { if (!el.classList.contains('hx-opt-empty')) el.classList.add('hx-opt-empty'); });
    };
    let pending = false;
    const schedule = function () {
      if (pending) return;
      pending = true;
      requestAnimationFrame(function () { pending = false; sync(); });
    };
    new MutationObserver(function (records) { if (hxRelevant(records)) schedule(); }).observe(document.body, { childList: true, subtree: true, characterData: true, attributes: true, attributeFilter: ['class', 'aria-checked'] });
    sync();
  }

  // Handy, Boost-Filterfenster mit Unterliste ("Druckermodell wählen" usw.): "Ergebnisse anzeigen" nach oben an die
  // Stelle des Suchfelds, das Suchfeld "Suchoptionen" nach unten über "Filter leeren" (Tan 2026-10-29).
  // Boosts eigene Knöpfe werden nicht verschoben (sonst bringt Boost sein Fenster durcheinander): oben steht ein
  // eigener Knopf, der Boosts "Ergebnisse anzeigen" drückt, das Suchfeld rutscht per CSS (order) ans Ende der Liste.
  // Danach wird nachgemessen; sitzt etwas falsch, wird alles zurückgenommen. Boost lädt in Claudes Testumgebung nicht.
  function initBoostFilterSwap() {
    if (!/^\/collections\/|^\/search/.test(location.pathname)) return;
    const visible = function (el) { return !!(el && el.getClientRects().length && getComputedStyle(el).visibility !== 'hidden'); };
    const childOf = function (anc, el) { let p = el; while (p && p.parentElement !== anc) p = p.parentElement; return p; };
    let proxy = null;
    let failed = false;
    const marked = [];
    const mark = function (el, cls) { if (!el.classList.contains(cls)) el.classList.add(cls); if (marked.indexOf(el) < 0) marked.push(el); };
    const reset = function () {
      marked.forEach(function (el) { el.classList.remove('hx-swap-col', 'hx-swap-last', 'hx-swap-list', 'hx-apply-hidden'); el.style.removeProperty('--hx-swap-min'); });
      marked.length = 0;
      if (proxy && proxy.isConnected) proxy.remove();
    };
    const sync = function () {
      const drawer = document.querySelector('.hx-boost-drawer');
      // Nach einem Fehlversuch erst beim nächsten Öffnen des Fensters wieder probieren
      if (!drawer) failed = false;
      if (failed) return;
      if (!drawer || !window.matchMedia('(max-width: 768.98px)').matches) { reset(); return; }
      const input = [...drawer.querySelectorAll('input')].find(function (i) { return visible(i) && /suchoption/i.test(i.placeholder || ''); });
      const apply = [...drawer.querySelectorAll('button, [role="button"]')].find(function (b) {
        return b !== proxy && /^\s*Ergebnisse anzeigen/.test(b.textContent) && (visible(b) || b.closest('.hx-apply-hidden'));
      });
      if (!input || !apply) { reset(); return; }
      // Liste der Werte: erstes sichtbares Element nach dem Suchfeld mit einem Filterwert
      const item = [...drawer.querySelectorAll('[class*="filter-option-item"], li')].find(function (el) {
        return visible(el) && !el.contains(input) && (input.compareDocumentPosition(el) & Node.DOCUMENT_POSITION_FOLLOWING);
      });
      if (!item) { reset(); return; }
      let panel = input.parentElement;
      while (panel && !panel.contains(item)) panel = panel.parentElement;
      if (!panel || panel === document.body) { reset(); return; }
      const searchBlock = childOf(panel, input);
      const applyAnchor = apply.parentElement && apply.parentElement.children.length === 1 && apply.parentElement !== drawer ? apply.parentElement : apply;
      if (applyAnchor.contains(input) || searchBlock.contains(apply)) { reset(); return; }
      mark(panel, 'hx-swap-col');
      mark(searchBlock, 'hx-swap-last');
      const listBlock = childOf(panel, item);
      if (listBlock && listBlock !== searchBlock) mark(listBlock, 'hx-swap-list');
      // Liste und Suchfeld unten am Fenster (Daumen, Tan 2026-10-29): die Spalte füllt die scrollende Fläche
      // ganz aus, die Liste rutscht per CSS (margin-top: auto) nach unten. Bei langen Listen wird normal gescrollt.
      let scroller = panel;
      while (scroller && scroller !== drawer && !/(auto|scroll)/.test(getComputedStyle(scroller).overflowY)) scroller = scroller.parentElement;
      if (scroller && /(auto|scroll)/.test(getComputedStyle(scroller).overflowY)) {
        const sr = scroller.getBoundingClientRect();
        const topInside = panel === scroller ? 0 : panel.getBoundingClientRect().top - sr.top + scroller.scrollTop;
        const want = Math.max(0, Math.floor(scroller.clientHeight - topInside - parseFloat(getComputedStyle(scroller).paddingBottom || 0)));
        const target = panel === scroller ? null : panel;
        if (target && Math.abs((parseFloat(target.style.getPropertyValue('--hx-swap-min')) || 0) - want) > 1) target.style.setProperty('--hx-swap-min', want + 'px');
      }
      mark(applyAnchor, 'hx-apply-hidden');
      if (!proxy) {
        proxy = document.createElement('button');
        proxy.type = 'button';
        proxy.className = 'hx-apply-top';
        proxy.addEventListener('click', function () {
          const real = [...document.querySelectorAll('.hx-apply-hidden button, button.hx-apply-hidden')].find(function (b) { return /Ergebnisse anzeigen/.test(b.textContent); });
          if (real) real.click();
        });
      }
      const label = apply.textContent.trim();
      if (proxy.textContent !== label) proxy.textContent = label;
      if (proxy.nextElementSibling !== searchBlock) panel.insertBefore(proxy, searchBlock);
      // Nachmessen: Knopf oben über der Liste, Suchfeld darunter. Beide kleben per CSS (sticky) am oberen bzw.
      // unteren Rand der scrollenden Liste; eine lange Liste ist also kein Fehler (sonst sprang es zurück).
      const p = proxy.getBoundingClientRect();
      const i = input.getBoundingClientRect();
      const okTop = p.height > 20 && p.bottom <= item.getBoundingClientRect().top + 1;
      const okSearch = i.height > 10 && i.top >= p.bottom;
      if (!okTop || !okSearch) { failed = true; reset(); }
    };
    let pending = false;
    new MutationObserver(function (records) {
      if (pending || !hxRelevant(records) || records.every(function (r) { return proxy && (r.target === proxy || proxy.contains(r.target)); })) return;
      pending = true;
      requestAnimationFrame(function () { pending = false; sync(); });
    }).observe(document.body, { childList: true, subtree: true, attributes: true, attributeFilter: ['class'] });
  }

  // Handy, Kategorieseite (Boost): in der Leiste "8 Produkte … Ansicht" mittig ein roter Knopf "Filter leeren",
  // nur solange ein Filter aktiv ist (Boost schreibt aktive Filter als pf_…-Parameter in die Adresse).
  // Tan 2026-10-29, zweite Fassung: Die erste lud die Seite neu und setzte die Leiste auf position: relative,
  // danach war die Seite verschoben. Jetzt: keine Boost-Hülle wird umgestellt (der Knopf richtet sich an der
  // ohnehin haftenden Leiste aus), und geleert wird über Boosts eigenes "Entfernen" im (kurz unsichtbaren)
  // Filterfenster plus "Ergebnisse anzeigen", ohne Neuladen.
  function initToolbarFilterClear() {
    if (!/^\/collections\/|^\/search/.test(location.pathname)) return;
    const visible = function (el) { return !!(el && el.getClientRects().length && getComputedStyle(el).visibility !== 'hidden'); };
    let btn = null;
    let busy = false;
    const active = function () {
      return [...new URLSearchParams(location.search).keys()].some(function (k) { return /^pf_/.test(k); });
    };
    const finish = function () { busy = false; document.documentElement.classList.remove('hx-boost-clearing'); };
    const clearAll = function () {
      if (busy) return;
      busy = true;
      document.documentElement.classList.add('hx-boost-clearing');
      const started = Date.now();
      let step = 0;
      let lastToggle = 0;
      const tick = function () {
        if (Date.now() - started > 6000) { finish(); return; }
        // Filterfenster offen = Boosts Knopf "Ergebnisse anzeigen" sichtbar (Klasse .hx-boost-drawer kommt evtl. später)
        const buttons = [...document.querySelectorAll('[class*="boost-sd"] :is(button, [role="button"], a), button[class*="boost-sd"], .hx-boost-drawer :is(button, [role="button"], a)')]
          .filter(function (b) { return visible(b) && !b.closest('.hx-toolbar-clear, .hx-filter-clear, .hx-apply-top'); });
        const open = buttons.some(function (b) { return /^\s*Ergebnisse anzeigen/.test(b.textContent); }) || !!document.querySelector('.hx-boost-drawer');
        if (step === 0) {
          const clear = open && buttons.find(function (b) { return /^\s*(Alle entfernen|Alles entfernen|Entfernen)\s*$/i.test(b.textContent); });
          if (clear) { clear.click(); step = 1; }
          else if (!open && Date.now() - lastToggle > 600) {
            const toggle = document.querySelector('.boost-sd__filter-tree-toggle-button-icon');
            const t = toggle ? (toggle.closest('button, [role="button"], .boost-sd__filter-tree-toggle-button') || toggle) : null;
            if (t) { lastToggle = Date.now(); t.click(); }
          }
        } else {
          const apply = buttons.find(function (b) { return /^\s*Ergebnisse anzeigen/.test(b.textContent) && !b.disabled; });
          if (apply) { apply.click(); setTimeout(finish, 400); return; }
          if (!open) { finish(); return; }
        }
        setTimeout(tick, 150);
      };
      tick();
    };
    const sync = function () {
      const mobile = window.matchMedia('(max-width: 768.98px)').matches;
      const bar = document.querySelector('.boost-sd__toolbar-container');
      const icons = mobile && active() && bar ? (bar.querySelector('[class*="view-as-icon"]') || bar.querySelector('[class*="view-as"]')) : null;
      if (!icons || !visible(icons)) { if (btn && btn.isConnected) btn.remove(); return; }
      if (!btn) {
        btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'hx-toolbar-clear';
        btn.textContent = 'Filter leeren';
        btn.addEventListener('click', clearAll);
      }
      if (btn.parentElement !== bar) bar.appendChild(btn);
      // Senkrecht auf der Linie der Ansicht-Icons, waagrecht in der Bildschirmmitte. Gemessen an der Hülle,
      // an der sich der Knopf ausrichtet (offsetParent, die haftende Leiste), ohne an Boost etwas umzustellen.
      const host = btn.offsetParent || bar;
      const r = host.getBoundingClientRect();
      const ir = icons.getBoundingClientRect();
      const top = Math.round(ir.top + ir.height / 2 - r.top - host.clientTop) + 'px';
      const left = Math.round(document.documentElement.clientWidth / 2 - r.left - host.clientLeft) + 'px';
      if (btn.style.getPropertyValue('--hx-clear-top') !== top) btn.style.setProperty('--hx-clear-top', top);
      if (btn.style.getPropertyValue('--hx-clear-left') !== left) btn.style.setProperty('--hx-clear-left', left);
    };
    let pending = false;
    new MutationObserver(function (records) {
      if (pending || !hxRelevant(records) || records.every(function (r) { return btn && (r.target === btn || btn.contains(r.target)); })) return;
      pending = true;
      requestAnimationFrame(function () { pending = false; sync(); });
    }).observe(document.body, { childList: true, subtree: true });
    window.addEventListener('popstate', sync);
    window.addEventListener('resize', sync);
    // Boost schreibt die Filter teils erst nach dem Neuzeichnen in die Adresse: Adresse jede halbe Sekunde vergleichen
    let lastSearch = location.search;
    setInterval(function () { if (location.search !== lastSearch) { lastSearch = location.search; sync(); } }, 500);
    sync();
  }

  // Boost-Filter (Desktop und Handy): "Alle entfernen", "Entfernen" und das X bei aktiven Filtern rot (Tan 2026-10-29).
  // Boost-Klassen sind hier nicht sicher bekannt, darum über Texte und SVGs markiert; Farben in custom-main.css.
  function initBoostRedClear() {
    if (!/^\/collections\/|^\/search/.test(location.pathname)) return;
    const sync = function () {
      document.querySelectorAll('[class*="boost-sd__filter"] :is(button, a, [role="button"]), [class*="refine-by"] :is(button, a, [role="button"])').forEach(function (el) {
        if (/^\s*(Alle entfernen|Alles entfernen|Entfernen)\s*$/i.test(el.textContent) && !el.classList.contains('hx-red-text')) el.classList.add('hx-red-text');
      });
      document.querySelectorAll('[class*="refine-by"] [class*="close"], [class*="refine-by"] [class*="cross"], [class*="refine-by"] [class*="remove"], [class*="refine-by"] [class*="-x"]').forEach(function (el) {
        if (!el.textContent.trim() && !el.classList.contains('hx-red-icon')) el.classList.add('hx-red-icon');
      });
    };
    let pending = false;
    new MutationObserver(function (records) {
      if (pending || !hxRelevant(records)) return;
      pending = true;
      requestAnimationFrame(function () { pending = false; sync(); });
    }).observe(document.body, { childList: true, subtree: true });
    sync();
  }

  // Patronen-Finder "Finde deine Druckerpatronen" (Hersteller / Serie / Modell, snippets/ttt-printermodelsearch-mh*.liquid),
  // Tan 2026-10-30: Die Browser-Auswahlliste war winzig und liess sich nicht scrollen. Darum eigene Auswahlliste
  // (16 px, scrollbar). Das originale <select> bleibt unsichtbar als Datenquelle: Die Snippets füllen es weiter und
  // reagieren auf "change". Tastatur und Screenreader wie beim Combobox-Muster (Pfeiltasten, Enter, Esc, Anfangsbuchstabe).
  function initTttSelects() {
    const valueProp = Object.getOwnPropertyDescriptor(HTMLSelectElement.prototype, 'value');
    const indexProp = Object.getOwnPropertyDescriptor(HTMLSelectElement.prototype, 'selectedIndex');
    let uid = 0;
    let openBox = null;
    // Am Handy die eingebaute Auswahl des Telefons (Tan 2026-10-30): das unsichtbare select liegt über der Box
    // und öffnet beim Antippen die scrollbare Liste von Android/iPhone. Aussehen in custom-main.css.
    const mobile = window.matchMedia('(max-width: 768.98px)');

    // Nach einer Wahl öffnet sich das nächste Feld von selbst, sobald die Snippets seine Einträge geladen haben (Tan 2026-10-30)
    function openNext(from) {
      const scope = from.closest('.hermex-ttt-customsearch') || document;
      const all = Array.prototype.slice.call(scope.querySelectorAll('.hx-ttt-select'));
      const next = all[all.indexOf(from) + 1];
      if (!next) return;
      const s = next.querySelector('select');
      let tries = 0;
      (function wait() {
        if (!document.contains(s)) return;
        if (!s.disabled && s.options.length > 1 && !s.value) {
          if (mobile.matches) {
            try { s.showPicker(); } catch (e) { /* iPhone/Safari: automatisches Öffnen nicht erlaubt */ }
          } else if (next.hxOpen) {
            next.querySelector('.hx-ttt-select__box').focus({ preventScroll: true });
            next.hxOpen();
          }
          return;
        }
        if (++tries < 40) setTimeout(wait, 100);
      })();
    }

    // Tipp auf ein noch gesperrtes Feld: das Feld, das zuerst gewählt werden muss, blinkt einmal und öffnet sich (Tan 2026-10-30)
    function guide(from) {
      const scope = from.closest('.hermex-ttt-customsearch') || document;
      const target = Array.prototype.find.call(scope.querySelectorAll('.hx-ttt-select'), function (w) {
        const s = w.querySelector('select');
        return s && !s.disabled && s.options.length && !s.value;
      });
      if (!target) return;
      const tBox = target.querySelector('.hx-ttt-select__box');
      const tSelect = target.querySelector('select');
      tBox.classList.remove('hx-ttt-flash');
      void tBox.offsetWidth;
      tBox.classList.add('hx-ttt-flash');
      setTimeout(function () { tBox.classList.remove('hx-ttt-flash'); }, 900);
      if (mobile.matches) {
        try { tSelect.showPicker(); } catch (e) { tSelect.focus(); }
      } else if (target.hxOpen) {
        tBox.focus({ preventScroll: true });
        target.hxOpen();
      }
    }

    function enhance(select) {
      if (select.dataset.hxTtt) return;
      select.dataset.hxTtt = 'true';
      const n = ++uid;
      const wrap = document.createElement('div');
      wrap.className = 'hx-ttt-select';
      const box = document.createElement('div');
      box.className = 'searchoption-ttsearch hx-ttt-select__box';
      box.setAttribute('role', 'combobox');
      box.setAttribute('aria-haspopup', 'listbox');
      box.setAttribute('aria-expanded', 'false');
      box.setAttribute('aria-controls', 'hx-ttt-list-' + n);
      box.id = 'hx-ttt-box-' + n;
      const label = select.parentNode.querySelector('.selectidlabel');
      if (label) {
        if (!label.id) label.id = 'hx-ttt-label-' + n;
        box.setAttribute('aria-labelledby', label.id + ' ' + box.id);
      }
      const list = document.createElement('ul');
      list.className = 'hx-ttt-select__list';
      list.id = 'hx-ttt-list-' + n;
      list.setAttribute('role', 'listbox');
      list.setAttribute('tabindex', '-1');
      if (label) list.setAttribute('aria-labelledby', label.id);
      list.hidden = true;
      select.parentNode.insertBefore(wrap, select);
      wrap.appendChild(select);
      wrap.appendChild(box);
      wrap.appendChild(list);
      select.classList.add('hx-ttt-select__native');
      select.setAttribute('tabindex', '-1');
      select.setAttribute('aria-hidden', 'true');

      let active = -1;
      let typed = '';
      let typedTimer;

      function items() { return list.querySelectorAll('[role="option"]'); }

      function sync() {
        const opt = select.options[select.selectedIndex];
        const off = select.disabled || !select.options.length;
        // Gesperrte Schritte (Serie/Modell vor der Auswahl davor) ohne "Bitte wählen" (Tan 2026-10-30)
        box.textContent = opt && !off ? opt.textContent : '\u00a0'; // geschütztes Leerzeichen hält die Feldhöhe
        box.setAttribute('aria-disabled', off ? 'true' : 'false');
        box.setAttribute('tabindex', off || mobile.matches ? '-1' : '0');
        // Platzhalter ("Bitte wählen", "Wähle die Serie/das Modell") nicht in der offenen Liste, nur im Feld (Tan 2026-10-30).
        // hidden blendet ihn auch in der Telefon-Auswahl aus (Android sicher, iPhone je nach iOS-Version)
        Array.prototype.forEach.call(select.options, function (o) { if (!o.value && !o.hidden) o.hidden = true; });
        if (mobile.matches) {
          select.removeAttribute('tabindex');
          select.removeAttribute('aria-hidden');
          box.setAttribute('aria-hidden', 'true');
        } else {
          select.setAttribute('tabindex', '-1');
          select.setAttribute('aria-hidden', 'true');
          box.removeAttribute('aria-hidden');
        }
        if ((off || mobile.matches) && !list.hidden) close();
        if (!list.hidden) build();
      }

      function build() {
        list.innerHTML = '';
        Array.prototype.forEach.call(select.options, function (opt, i) {
          const li = document.createElement('li');
          li.id = list.id + '-' + i;
          li.className = 'hx-ttt-select__option';
          li.setAttribute('role', 'option');
          li.setAttribute('aria-selected', i === select.selectedIndex ? 'true' : 'false');
          if (opt.disabled) li.setAttribute('aria-disabled', 'true');
          if (!opt.value) li.hidden = true;
          li.dataset.index = i;
          li.textContent = opt.textContent;
          list.appendChild(li);
        });
        setActive(active < 0 ? select.selectedIndex : active, false);
      }

      function firstReal() {
        const k = Array.prototype.findIndex.call(select.options, function (o) { return !!o.value; });
        return k < 0 ? 0 : k;
      }

      function setActive(i, scroll) {
        const all = items();
        if (!all.length) return;
        active = Math.max(firstReal(), Math.min(i, all.length - 1));
        all.forEach(function (li, k) { li.classList.toggle('is-active', k === active); });
        box.setAttribute('aria-activedescendant', all[active].id);
        if (scroll !== false) {
          const li = all[active];
          if (li.offsetTop < list.scrollTop) list.scrollTop = li.offsetTop;
          else if (li.offsetTop + li.offsetHeight > list.scrollTop + list.clientHeight) list.scrollTop = li.offsetTop + li.offsetHeight - list.clientHeight;
        }
      }

      // Höhe an den freien Platz anpassen; unten nicht hinter die Handy-Leiste, notfalls nach oben öffnen
      function place() {
        const rect = box.getBoundingClientRect();
        const bar = parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--hx-bottom-bar-height')) || 0;
        const barShown = document.querySelector('.hx-bottom-bar') && window.matchMedia('(max-width: 768.98px)').matches;
        const below = window.innerHeight - rect.bottom - (barShown ? bar : 0) - 12;
        const above = rect.top - 12;
        const up = below < 200 && above > below;
        wrap.classList.toggle('is-up', up);
        list.style.maxHeight = Math.max(120, Math.min(320, up ? above : below)) + 'px';
      }

      function open() {
        if (box.getAttribute('aria-disabled') === 'true' || mobile.matches) return;
        if (openBox && openBox !== close) openBox();
        active = select.selectedIndex;
        list.hidden = false;
        build();
        place();
        box.setAttribute('aria-expanded', 'true');
        wrap.classList.add('is-open');
        hxTttOpenState();
        setActive(active);
        openBox = close;
      }

      function close() {
        list.hidden = true;
        box.setAttribute('aria-expanded', 'false');
        box.removeAttribute('aria-activedescendant');
        wrap.classList.remove('is-open', 'is-up');
        hxTttOpenState();
        active = -1;
        if (openBox === close) openBox = null;
      }

      function choose(i) {
        const opt = select.options[i];
        close();
        if (!opt || opt.disabled) return;
        if (i !== select.selectedIndex) {
          indexProp.set.call(select, i);
          sync();
          select.dispatchEvent(new Event('input', { bubbles: true }));
          select.dispatchEvent(new Event('change', { bubbles: true }));
        }
        box.focus({ preventScroll: true });
        if (opt.value) setTimeout(function () { openNext(wrap); }, 50);
      }

      box.addEventListener('click', function () {
        if (box.getAttribute('aria-disabled') === 'true') { guide(wrap); return; }
        list.hidden ? open() : close();
      });
      wrap.hxOpen = open;

      // mousedown statt click verhindert, dass die Box den Fokus verliert, bevor gewählt ist
      list.addEventListener('mousedown', function (event) { event.preventDefault(); });
      list.addEventListener('click', function (event) {
        const li = event.target.closest('[role="option"]');
        if (li) choose(Number(li.dataset.index));
      });
      list.addEventListener('mousemove', function (event) {
        const li = event.target.closest('[role="option"]');
        if (li && Number(li.dataset.index) !== active) setActive(Number(li.dataset.index), false);
      });

      box.addEventListener('keydown', function (event) {
        const isOpen = !list.hidden;
        const count = select.options.length;
        switch (event.key) {
          case 'ArrowDown':
          case 'ArrowUp':
            event.preventDefault();
            if (!isOpen) { open(); return; }
            if (event.altKey) { choose(active); return; }
            setActive(active + (event.key === 'ArrowDown' ? 1 : -1));
            return;
          case 'Home':
          case 'End':
            if (!isOpen) return;
            event.preventDefault();
            setActive(event.key === 'Home' ? 0 : count - 1);
            return;
          case 'PageDown':
          case 'PageUp':
            if (!isOpen) return;
            event.preventDefault();
            setActive(active + (event.key === 'PageDown' ? 10 : -10));
            return;
          case 'Enter':
          case ' ':
            if (event.key === ' ' && typed) break;
            event.preventDefault();
            isOpen ? choose(active) : open();
            return;
          case 'Escape':
            if (isOpen) { event.preventDefault(); close(); }
            return;
          case 'Tab':
            if (isOpen) close();
            return;
        }
        // Anfangsbuchstaben tippen springt zum passenden Eintrag
        if (event.key.length === 1 && !event.ctrlKey && !event.metaKey && !event.altKey) {
          clearTimeout(typedTimer);
          typed += event.key.toLowerCase();
          typedTimer = setTimeout(function () { typed = ''; }, 600);
          const start = isOpen ? active : select.selectedIndex;
          for (let k = 1; k <= count; k++) {
            const i = (start + (typed.length > 1 ? 0 : k) + count) % count;
            if (select.options[i].value && select.options[i].textContent.trim().toLowerCase().indexOf(typed) === 0) {
              if (isOpen) setActive(i); else choose(i);
              break;
            }
          }
        }
      });

      box.addEventListener('blur', function () { if (!list.hidden) close(); });

      // Die Snippets setzen .value direkt (gespeicherte Auswahl) und tauschen Optionen per innerHTML aus
      Object.defineProperty(select, 'value', {
        configurable: true,
        get: function () { return valueProp.get.call(this); },
        set: function (v) {
          valueProp.set.call(this, v);
          // Gespeicherte Werte in den Kollektions-Metafeldern sind teils klein geschrieben ("9020cdw" statt "9020CDW")
          if (v && valueProp.get.call(this) !== String(v)) {
            const want = String(v).trim().toLowerCase();
            const hit = Array.prototype.find.call(this.options, function (o) { return o.value.trim().toLowerCase() === want; });
            if (hit) valueProp.set.call(this, hit.value);
          }
          sync();
        }
      });
      Object.defineProperty(select, 'selectedIndex', {
        configurable: true,
        get: function () { return indexProp.get.call(this); },
        set: function (v) { indexProp.set.call(this, v); sync(); }
      });
      select.addEventListener('change', sync);
      // Handy: Wahl in der Telefon-Auswahl (choose() läuft dort nicht). Ohne vorherigen Fingertipp blockt der Browser showPicker.
      select.addEventListener('change', function () {
        if (mobile.matches && select.value) setTimeout(function () { openNext(wrap); }, 50);
      });
      mobile.addEventListener('change', sync);
      new MutationObserver(sync).observe(select, { childList: true, subtree: true, characterData: true, attributes: true, attributeFilter: ['disabled'] });
      sync();
    }

    function scan() {
      document.querySelectorAll('select.searchoption-ttsearch').forEach(enhance);
    }

    document.addEventListener('mousedown', function (event) {
      if (openBox && !event.target.closest('.hx-ttt-select')) openBox();
    });
    // Nur bei geänderter Breite schliessen (am Handy feuert "resize" auch beim Scrollen, wenn die Adressleiste einklappt)
    let lastWidth = window.innerWidth;
    window.addEventListener('resize', function () {
      if (window.innerWidth === lastWidth) return;
      lastWidth = window.innerWidth;
      if (openBox) openBox();
    });
    scan();
  }

  // Boost-Text unter "Mehr anzeigen" auf Deutsch (Tan 2026-10-30): "Showing 1 - 144 of 1504 products" wird zu
  // "1–144 von 1504 Produkten". Boost zeichnet den Text mit React, oft in mehreren Textstücken. Darum nur die Textwerte
  // ändern (keine Knoten entfernen) und bei jeder Änderung neu prüfen. Boost lädt in Claudes Testumgebung nicht.
  function initBoostShowingText() {
    const pattern = /^\s*Showing\s+(\d[\d'’.,]*)\s*-\s*(\d[\d'’.,]*)\s+of\s+(\d[\d'’.,]*)\s+products?\s*$/i;
    let queued = false;

    function translate() {
      queued = false;
      const walker = document.createTreeWalker(document.body, NodeFilter.SHOW_TEXT, {
        acceptNode: function (node) { return /Showing/i.test(node.nodeValue) ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_SKIP; }
      });
      const parents = [];
      while (walker.nextNode()) {
        const parent = walker.currentNode.parentElement;
        if (parent && parents.indexOf(parent) === -1) parents.push(parent);
      }
      parents.forEach(function (el) {
        if (Array.prototype.some.call(el.childNodes, function (n) { return n.nodeType !== 3; })) return;
        const match = el.textContent.match(pattern);
        if (!match) return;
        const total = match[3];
        const text = match[1] + '–' + match[2] + ' von ' + total + (total.replace(/\D/g, '') === '1' ? ' Produkt' : ' Produkten');
        el.childNodes.forEach(function (n, i) { n.nodeValue = i === 0 ? text : ''; });
      });
    }

    // gebündelt alle 100 ms, damit Boosts viele Änderungen beim Zeichnen nicht bremsen
    function queue() {
      if (queued) return;
      queued = true;
      window.setTimeout(translate, 100);
    }

    new MutationObserver(function (records) { if (hxRelevant(records)) queue(); }).observe(document.body, { childList: true, subtree: true, characterData: true });
    queue();
  }

  // Boost-Notfall-Ansicht (Boost meldet einen Fehler und zeigt seine einfache Liste "Sort by", "Add to cart"), z. B. auf
  // den Druckermodell-Seiten (Tan 2026-10-30): Leiste wie auf der Kategorieseite (haftet oben, "Sortieren nach:",
  // "Filter entfernen" rot) und dieselben Hermex-Karten wie in der Doofinder-Suche (sections/hx-suchkarte.liquid).
  // Klappt das Laden einer Karte nicht, bleibt Boosts Karte stehen. Ursache (Boost-Fehler) liegt im Boost-Admin.
  function initBoostFallbackLayout() {
    if (!/^\/collections\/|^\/search/.test(location.pathname)) return;
    let queued = false;

    function productPath(link) {
      try {
        const url = new URL(link.getAttribute('href'), location.origin);
        const match = url.pathname.match(/\/products\/[^/]+/);
        return match ? match[0] : '';
      } catch (e) {
        return '';
      }
    }

    function sync() {
      queued = false;
      document.querySelectorAll('.boost-sd-fb').forEach(function (fb) {
        fb.classList.add('hx-fb');
        const label = fb.querySelector('.boost-sd__sorting-label');
        if (label && /^\s*Sort by\s*:?\s*$/i.test(label.textContent)) label.textContent = 'Sortieren nach:';
        const count = fb.querySelector('.boost-sd-fb__count');
        if (count) {
          const m = count.textContent.match(/^\s*(\d[\d'’.,]*)\s+products?\s*$/i);
          if (m) count.textContent = m[1] + (m[1] === '1' ? ' Produkt' : ' Produkte');
        }
        fb.querySelectorAll('a, button, [role="button"]').forEach(function (el) {
          if (/^\s*(Filter entfernen|Alle entfernen|Alles entfernen|Clear all|Clear filters?)\s*$/i.test(el.textContent)) {
            if (/^\s*Clear/i.test(el.textContent)) el.textContent = 'Filter entfernen';
            el.classList.add('hx-red-text', 'hx-fb-clear');
          }
        });
        fb.querySelectorAll('.boost-sd-fb__card').forEach(function (card) {
          const link = card.querySelector('a[href*="/products/"]');
          const path = link && productPath(link);
          if (!path || card.dataset.hxFb === path) return;
          card.dataset.hxFb = path;
          dfdLoad(path).then(function (html) {
            if (!html || card.dataset.hxFb !== path) return;
            const old = card.querySelector(':scope > .hx-dfd-card');
            if (old) old.remove();
            card.insertAdjacentHTML('beforeend', html);
            card.classList.add('hx-fb-card');
            dfdFormScript(card.querySelector(':scope > .hx-dfd-card'));
          });
        });
      });
    }

    function queue() {
      if (queued) return;
      queued = true;
      window.requestAnimationFrame(sync);
    }

    window.addEventListener('boost-sd-enable-product-filter-fallback', queue);
    new MutationObserver(function (records) {
      if (records.some(function (r) { return r.target.closest && r.target.closest('.boost-sd__filter-product-list'); })) queue();
    }).observe(document.body, { childList: true, subtree: true });
    queue();
  }

  // Druckermodell-Seiten (sections/hx-modell-produkte.liquid, Tan 2026-10-30): "Anzeigen als" Raster oder Liste wie bei Boost.
  // Die Wahl merkt sich der Browser (nur Komfort, ohne Speicher gilt Raster).
  function initModellListView() {
    const list = document.querySelector('.hx-ml');
    if (!list) return;
    const buttons = list.querySelectorAll('[data-hx-view]');
    function apply(view) {
      list.classList.toggle('is-list', view === 'list');
      buttons.forEach(function (btn) {
        const on = btn.dataset.hxView === view;
        btn.classList.toggle('is-active', on);
        btn.setAttribute('aria-pressed', on ? 'true' : 'false');
      });
    }
    let saved = 'grid';
    try { saved = localStorage.getItem('hxMlView') || 'grid'; } catch (e) {}
    apply(saved);
    buttons.forEach(function (btn) {
      btn.addEventListener('click', function () {
        apply(btn.dataset.hxView);
        try { localStorage.setItem('hxMlView', btn.dataset.hxView); } catch (e) {}
      });
    });
  }

  onReady(function () {
    initCartOpenState();
    initTttSelects();
    initModellListView();
    initBoostShowingText();
    initBoostFallbackLayout();
    initSwipeHint();
    initIconsTextTap();
    // initBoostFilterSwap(); und initToolbarFilterClear(); vorerst aus (Tan 2026-10-29): am echten Boost doppelt
    // gezeichnete Liste und verschobenes Fenster. Erst wieder einschalten, wenn am echten Boost getestet.
    initBoostRedClear();
    initBoostFilterClear();
    initBoostOpenOption();
    initBoostCollapseArrow();
    initBoostHideZero();
    initBoostFilterAutoClose();
    initPatronenNrFilter();
    initWholePriceFormat();
    initDoofinderCards();
    initOnePanel();
    initCartFreeShipping();
    initBoostHoverImages();
    initBoostFlyToCart();
    initProductDescriptionToggles();
    initPolicyModalClose();
    initUmschaltseite();
    initPrinterModelSearch();
    initFirstVisitReturnButtons();
    initMissionStatementToggle();
    initBoostToolbarBreadcrumbState();
    initShippingPopup();
    initCookieBannerAutoAccept();
    initPrinterLinks();
    initRivoCheck();
    initInfoTileToggles();
    initStickyOptionsHighlight();
    initKlaviyoTeaser();
  });

  onWindowLoad(function () {
    tightenCardBottoms();
    initStickyHeaderPosition();
    initBoostToolbarTop();
    initShippingCutoffTimer();
  });
}());